import React, { useState, useEffect, useCallback, memo } from 'react';
import { Container, Tabs, Tab, Table, Button, Form, Modal, Spinner, Toast, Badge, Nav, Alert, Row, Col, Card } from 'react-bootstrap';
import api from '../../config/api';
import './AdminPanel.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import ReturnRequestsAdmin from './ReturnRequestsAdmin';
import FeaturedProducts from './FeaturedProducts';
import StockManager from './StockManager';
import AssetManager from './AssetManager';
import ProductTypesManager from '../../components/admin/ProductTypesManager';
import Parameters from './Parameters';
import AnalyticsDashboard from '../../components/admin/AnalyticsDashboard';

const AdminPanel = memo(() => {
  const [activeTab, setActiveTab] = useState('stock-manager');
  const [productsList, setProductsList] = useState([]);
  const [customProductsList, setCustomProductsList] = useState([]);
  const [productDetails, setProductDetails] = useState({});
  const [collections, setCollections] = useState([]);
  const [phoneModels, setPhoneModels] = useState([]);
  const [phoneTemplates, setPhoneTemplates] = useState([]);
  const [designLibrary, setDesignLibrary] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    collection: '',
    phone_model: '',
    description: '',
    is_active: true,
    is_approval: true,
    product_type_id: ''
  });
  const [loading, setLoading] = useState(true);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [noMaskImageFile, setNoMaskImageFile] = useState(null);
  const [noMaskImagePreview, setNoMaskImagePreview] = useState(null);
  
  // Ürün detay görselleri için state tanımlamaları
  const [productDetailsImages, setProductDetailsImages] = useState([]);
  const [productDetailsImageFiles, setProductDetailsImageFiles] = useState([]);
  const [productDetailsImagePreviews, setProductDetailsImagePreviews] = useState([]);
  const [showImageGallery, setShowImageGallery] = useState(false);
  const [imagePreviewGallery, setImagePreviewGallery] = useState([]);
  
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [customProductSearchTerm, setCustomProductSearchTerm] = useState('');
  const [phoneModelSearchTerm, setPhoneModelSearchTerm] = useState('');
  const [collectionSearchTerm, setCollectionSearchTerm] = useState('');
  const [groupedPhoneModels, setGroupedPhoneModels] = useState({});
  const [buttonLoading, setButtonLoading] = useState({});
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const [templateUploadModal, setTemplateUploadModal] = useState({
    show: false,
    modelId: null,
    modelName: '',
    isTemplate: true
  });
  const [templateImageFile, setTemplateImageFile] = useState(null);
  const [templateImagePreview, setTemplateImagePreview] = useState(null);
  const [uploadingTemplate, setUploadingTemplate] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [updatingOrderStatus, setUpdatingOrderStatus] = useState(false);
  const [printingLabel, setPrintingLabel] = useState(false);
  const [printingOrderId, setPrintingOrderId] = useState(null);
  const [pdfModal, setPdfModal] = useState({ show: false, url: '', orderNumber: '' });
  const [deletingOrder, setDeletingOrder] = useState(false);
  const [showDeleteOrderModal, setShowDeleteOrderModal] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);
  
  // Cache Management States
  const [cacheStats, setCacheStats] = useState(null);
  const [cacheHealth, setCacheHealth] = useState(null);
  const [loadingCache, setLoadingCache] = useState(false);
  const [clearingCache, setClearingCache] = useState(false);
  const [phoneModelDetails, setPhoneModelDetails] = useState({});
  const [orderFilters, setOrderFilters] = useState({
    searchTerm: '',
    startDate: '',
    endDate: '',
    status: '',
    paymentStatus: '',
    paymentMethod: '',
    minAmount: '',
    maxAmount: ''
  });
  const [designLibrarySearchTerm, setDesignLibrarySearchTerm] = useState('');
  const [selectedProductTypeForColors, setSelectedProductTypeForColors] = useState('');
  
  // Stock Modal States for Phone Model Colors
  const [showStockModal, setShowStockModal] = useState(false);
  const [stockModalData, setStockModalData] = useState({
    phoneModelId: null,
    colorId: null,
    phoneModelName: '',
    colorName: '',
    colorCode: '',
    stock: 0
  });
    const [addingColor, setAddingColor] = useState(false);

  // Image error handling utility
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.style.display = 'none';
    // Show a fallback icon instead of loading placeholder
    const fallbackIcon = document.createElement('div');
    fallbackIcon.innerHTML = '📷';
    fallbackIcon.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background-color: #f8f9fa;
      color: #6c757d;
      font-size: 1.5rem;
    `;
    e.target.parentNode.appendChild(fallbackIcon);
  };

  // Phone Model Colors state
  const [phoneModelColors, setPhoneModelColors] = useState([]);
  const [phoneModelColorsMap, setPhoneModelColorsMap] = useState({});
  const [colors, setColors] = useState([]);
  const [colorSearchTerm, setColorSearchTerm] = useState('');
  const [selectedColor, setSelectedColor] = useState(null);
  const [colorFormData, setColorFormData] = useState({
    name: '',
    code: '',
    is_active: true
  });
  const [colorLoading, setColorLoading] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [showImagePreview, setShowImagePreview] = useState(false);

  // Genişletilebilir hücreler için state ekleyelim
  const [expandedCells, setExpandedCells] = useState({});

  // Hücreyi genişletme/daraltma fonksiyonu
  const toggleCellExpansion = (cellId) => {
    setExpandedCells(prev => ({
      ...prev,
      [cellId]: !prev[cellId]
    }));
  };

  // Genişletilebilir hücre bileşeni
  const ExpandableCell = ({ content, cellId }) => {
    const isExpanded = expandedCells[cellId];
    
    return (
      <div 
        className={`expandable-cell ${isExpanded ? 'expanded' : ''}`}
        onClick={() => toggleCellExpansion(cellId)}
        title={isExpanded ? "Daraltmak için tıklayın" : "Genişletmek için tıklayın"}
      >
        {content}
      </div>
    );
  };

  // Görsel önizleme fonksiyonu
  const handleImagePreview = (imageUrl) => {
    window.open(imageUrl, '_blank');
  };

  // Sayfa dışına tıklandığında tooltip'i kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Eğer tıklanan eleman phone-models-cell sınıfına sahip değilse tooltip'i kapat
      if (!event.target.closest('.phone-models-cell')) {
        setActiveTooltip(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const showToast = useCallback((message, type = 'success') => {
    setToast({ show: true, message, type });
  }, []);

  const handleColorFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setColorFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const updatePhoneModels = useCallback((models) => {
    setPhoneModels(models);
    if (models.length > 0) {
      const grouped = models.reduce((acc, model) => {
        if (!acc[model.brand]) {
          acc[model.brand] = [];
        }
        acc[model.brand].push(model);
        return acc;
      }, {});
      setGroupedPhoneModels(grouped);
    }
  }, []);

  const fetchCollections = useCallback(async () => {
    try {
      const response = await api.get('/admin/collections');
      setCollections(response.data || []);
    } catch (error) {
      showToast('Koleksiyonlar yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchProductTypes = useCallback(async () => {
    try {
      const response = await api.get('/admin/product-types');
      setProductTypes(response.data || []);
    } catch (error) {
      showToast('Ürün tipleri yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchProducts = useCallback(async () => {
    try {
      const response = await api.get('/admin/products');
      setProductsList(response.data || []);
    } catch (error) {
      showToast('Ürünler yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchCustomProducts = useCallback(async () => {
    try {
      const response = await api.get('/admin/custom-products');
      setCustomProductsList(response.data || []);
    } catch (error) {
      showToast('Özel tasarım ürünler yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchPhoneModels = useCallback(async (productTypeId = null) => {
    try {
      let url = '/admin/phone-models';
      if (productTypeId) {
        url += `?product_type_id=${productTypeId}`;
      }
      const response = await api.get(url);
      updatePhoneModels(response.data);
    } catch (error) {
      showToast('Telefon modelleri yüklenemedi!', 'danger');
    }
  }, [showToast, updatePhoneModels]);

  const fetchPhoneTemplates = useCallback(async () => {
    try {
      const response = await api.get('/phone-templates');
      setPhoneTemplates(response.data || []);
    } catch (error) {
      showToast('Telefon şablonları yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchOrders = useCallback(async () => {
    try {
      const response = await api.get('/admin/orders');
      setOrders(response.data || []);
    } catch (error) {
      showToast('Siparişler yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchDesignLibrary = useCallback(async () => {
    try {
      const response = await api.get('/admin/design_library');
      setDesignLibrary(response.data || []);
    } catch (error) {
      showToast('Tasarımlar yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchColors = useCallback(async () => {
    try {
      const response = await api.get('/admin/colors');
      setColors(response.data || []);
    } catch (error) {
      showToast('Renkler yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchPhoneModelColors = useCallback(async () => {
    try {
      const response = await api.get('/admin/phone-model-colors');
      
      // Filter out any relations where product_colors is null
      const validRelations = response.data.filter(relation => 
        relation && relation.product_colors && relation.phone_models
      );
      
      setPhoneModelColors(validRelations);
      
      // Group by phone_model_id for easier access
      const groupedByModel = validRelations.reduce((acc, relation) => {
        const modelId = relation.phone_model_id;
        if (!acc[modelId]) {
          acc[modelId] = [];
        }
        acc[modelId].push(relation);
        return acc;
      }, {});
      
      setPhoneModelColorsMap(groupedByModel);
    } catch (error) {
      console.error('Error fetching phone model colors:', error);
      showToast('Telefon modeli renkleri yüklenemedi!', 'danger');
    }
  }, [showToast]);

  const fetchProductDetails = async (productId) => {
    try {
      const response = await api.get(`/admin/products/${productId}`);
      setProductDetails(prev => ({...prev, [productId]: response.data}));
    } catch (error) {
      showToast('Ürün detayları yüklenemedi!', 'danger');
    }
  };

  const fetchPhoneModelDetails = async (modelId) => {
    try {
      const response = await api.get(`/admin/phone-models/${modelId}`);
      setPhoneModelDetails(prev => ({...prev, [modelId]: response.data}));
    } catch (error) {
      showToast('Model detayları yüklenemedi!', 'danger');
    }
  };

  useEffect(() => {
    if (selectedOrder) {
      // Yeni format kontrolü: cart_items.items.items yapısı
      let cartItems = [];
      
      if (selectedOrder.cart_items && Array.isArray(selectedOrder.cart_items)) {
        // Eski format: doğrudan dizi
        cartItems = selectedOrder.cart_items;
      } else if (selectedOrder.cart_items && typeof selectedOrder.cart_items === 'object') {
        // Yeni format: { items: { items: [...] } }
        if (selectedOrder.cart_items.items && selectedOrder.cart_items.items.items) {
          cartItems = selectedOrder.cart_items.items.items;
        }
      }
      
      // Ürün detaylarını yükle
      cartItems.forEach(item => {
        if (!productDetails[item.product_id]) {
          fetchProductDetails(item.product_id);
        }
        if (!phoneModelDetails[item.phone_model_id]) {
          fetchPhoneModelDetails(item.phone_model_id);
        }
      });
    }
  }, [selectedOrder]);

  useEffect(() => {
    let mounted = true;
    const controller = new AbortController();

    const loadData = async () => {
      if (!mounted) return;
      
      try {
        setLoading(true);
        
        await Promise.all([
          fetchCollections(),
          fetchProductTypes(),
          fetchProducts(),
          fetchCustomProducts(),
          fetchPhoneModels(),
          fetchOrders(),
          fetchDesignLibrary(),
          fetchColors(),
          fetchPhoneModelColors(),
          fetchPhoneTemplates()
        ]);
      } catch (error) {
        if (mounted) {
          console.error('AdminPanel - Error fetching data:', error);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };
    
    loadData();
    
    return () => {
      mounted = false;
      controller.abort();
    };
  }, [fetchCollections, fetchProducts, fetchCustomProducts, fetchPhoneModels, fetchOrders, fetchDesignLibrary, fetchColors, fetchPhoneModelColors, fetchPhoneTemplates]);

  // Cache Management tab açıldığında stats'ları yükle
  useEffect(() => {
    if (activeTab === 'cache-manager') {
      fetchCacheStats();
    }
  }, [activeTab]);

  const handleModelSelect = (modelId) => {
    setSelectedModels(prev => {
      if (prev.includes(modelId)) {
        return prev.filter(id => id !== modelId);
      } else {
        return [...prev, modelId];
      }
    });
  };

  const filteredProducts = productSearchTerm
    ? productsList.filter(product =>
        product.name.toLowerCase().includes(productSearchTerm.toLowerCase())
      )
    : productsList;

  const filteredPhoneModels = Object.entries(groupedPhoneModels).reduce((acc, [brand, models]) => {
    const filteredModels = models.filter(model => 
      `${model.brand} ${model.model_name}`.toLowerCase().includes(phoneModelSearchTerm.toLowerCase())
    );
    if (filteredModels.length > 0) {
      acc[brand] = filteredModels;
    }
    return acc;
  }, {});

  const filteredCollections = collections.filter(collection =>
    collection.name.toLowerCase().includes(collectionSearchTerm.toLowerCase()) ||
    collection.description?.toLowerCase().includes(collectionSearchTerm.toLowerCase())
  );

  const filteredOrders = orders.filter(order => {
    // Search term filter (order number, customer name, email)
    const searchMatch = !orderFilters.searchTerm || 
      order.order_number?.toLowerCase().includes(orderFilters.searchTerm.toLowerCase()) ||
      `${order.first_name} ${order.last_name}`.toLowerCase().includes(orderFilters.searchTerm.toLowerCase()) ||
      order.email?.toLowerCase().includes(orderFilters.searchTerm.toLowerCase());

    // Date range filter
    const orderDate = new Date(order.created_at);
    const startDate = orderFilters.startDate ? new Date(orderFilters.startDate) : null;
    const endDate = orderFilters.endDate ? new Date(orderFilters.endDate) : null;
    const dateMatch = (!startDate || orderDate >= startDate) && (!endDate || orderDate <= endDate);

    // Status filter
    const statusMatch = !orderFilters.status || order.status === orderFilters.status;

    // Payment status filter
    const paymentMatch = !orderFilters.paymentStatus || order.payment_status === orderFilters.paymentStatus;

    // Payment method filter
    const paymentMethodMatch = !orderFilters.paymentMethod || order.payment_method === orderFilters.paymentMethod;

    // Amount range filter
    const amountMatch = (!orderFilters.minAmount || order.total_amount >= Number(orderFilters.minAmount)) &&
      (!orderFilters.maxAmount || order.total_amount <= Number(orderFilters.maxAmount));

    return searchMatch && dateMatch && statusMatch && paymentMatch && paymentMethodMatch && amountMatch;
  });

  const handleAdd = (type) => {
    console.log('handleAdd type:', type);
    setModalType(`add_${type}`);
    setSelectedItem(null);
    setImageFile(null);
    setImagePreview(null);
    setNoMaskImageFile(null);
    setNoMaskImagePreview(null);
    setSelectedModels([]);
    
    // Reset product details images
    setProductDetailsImages([]);
    setProductDetailsImageFiles([]);
    setProductDetailsImagePreviews([]);
    
    if (type === 'products') {
      setFormData({
        name: '',
        price: '',
        description: '',
        collection_id: '',
        is_active: true
      });
    } else if (type === 'collections') {
      setFormData({
        name: '',
        description: '',
        image: ''
      });
    } else if (type === 'phone_models') {
      setFormData({
        brand: '',
        model_name: '',
        is_active: true
      });
    } else if (type === 'design_library') {
      setFormData({
        name: '',
        description: '',
        category: '',
        image_url: '',
        display_order: '',
        is_active: true
      });
    }
    
    setShowModal(true);
  };

  const handleEdit = async (type, item) => {
    setModalType(`edit_${type}`);
    setSelectedItem(item);
    setFormData({
      ...item,
      is_approval: item.is_approval !== undefined ? item.is_approval : false // Ensure is_approval is set
    });
    setImagePreview(null);
    setNoMaskImagePreview(null);
    
    // Reset product details images
    setProductDetailsImages([]);
    setProductDetailsImageFiles([]);
    setProductDetailsImagePreviews([]);
    
    if (type === 'products' || type === 'custom-products') {
      if (item.images) {
        setImagePreview(item.images);
      }
      if (item.no_mask) {
        setNoMaskImagePreview(item.no_mask);
      }
      
      // Ürün detay görsellerini yükle
      if (item.product_details_images && Array.isArray(item.product_details_images)) {
        setProductDetailsImages(item.product_details_images);
        setProductDetailsImagePreviews(item.product_details_images);
      }

      // Ürün tipine göre telefon modellerini yükle
      if (item.product_type_id) {
        fetchPhoneModels(item.product_type_id);
      } else {
        fetchPhoneModels();
      }
      
      try {
        const endpoint = type === 'products' 
          ? `/admin/products/${item.id}/phone-models` 
          : `/admin/custom-products/${item.id}/phone-models`;
        
        const response = await api.get(endpoint);
        const selectedModelIds = response.data.map(m => m.phone_model_id.toString());
        setSelectedModels(selectedModelIds);
      } catch (error) {
        console.error('Telefon modelleri yüklenirken hata:', error);
        showToast('Telefon modelleri yüklenirken hata oluştu!', 'danger');
      }
    } else if (type === 'design_library') {
      if (item.image_url) {
        setImagePreview(item.image_url);
      }
    }
    
    setShowModal(true);
  };

  const handleDelete = async (type, id) => {
    setConfirmModal({
      show: true,
      title: 'Silme İşlemi',
      message: 'Bu öğeyi silmek istediğinizden emin misiniz?',
      onConfirm: async () => {
        try {
          setButtonLoading(prev => ({ ...prev, [id]: true }));
          
          if (type === 'design_library') {
            await api.delete(`/admin/design_library/${id}`);
          } else if (type === 'custom-products') {
            await api.delete(`/admin/custom-products/${id}`);
          } else {
            const url = `/admin/${type === 'phone_models' ? 'phone-models' : type}/${id}`;
            await api.delete(url);
          }

          if (type === 'collections') {
            fetchCollections();
          } else if (type === 'products') {
            fetchProducts();
          } else if (type === 'custom-products') {
            fetchCustomProducts();
          } else if (type === 'phone_models') {
            fetchPhoneModels();
          } else if (type === 'design_library') {
            fetchDesignLibrary();
          }

          showToast('Başarıyla silindi!', 'success');
        } catch (error) {
          showToast('Silme işlemi başarısız oldu!', 'danger');
        } finally {
          setButtonLoading(prev => ({ ...prev, [id]: false }));
        }
      }
    });
  };

  // handleImageUpload fonksiyonunu düzenleyelim
  const handleImageUpload = async (file) => {
    if (!file) return null;
    
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      const response = await api.post('/admin/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return response.data.imageUrl;
    } catch (error) {
      console.error('Resim yükleme hatası:', error);
      showToast('Resim yüklenirken hata oluştu!', 'danger');
      return null;
    }
  };

  // handleNoMaskImageUpload fonksiyonunu düzenleyelim
  const handleNoMaskImageUpload = async (file) => {
    if (!file) return null;
    
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      const response = await api.post('/admin/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return response.data.imageUrl;
    } catch (error) {
      console.error('Maskesiz resim yükleme hatası:', error);
      showToast('Maskesiz resim yüklenirken hata oluştu!', 'danger');
      return null;
    }
  };

  const handleColorAdd = async () => {
    try {
      setColorLoading(true);
      
      const response = await api.post('/admin/colors', colorFormData);
      
      showToast('Renk başarıyla eklendi!', 'success');
      setColorFormData({
        name: '',
        code: '',
        is_active: true
      });
      
      // Refresh colors list
      await fetchColors();
      
      // Also refresh phone model colors to ensure UI is up to date
      setTimeout(() => {
        fetchPhoneModelColors();
      }, 500);
      
    } catch (error) {
      console.error('Error adding color:', error);
      showToast('Renk eklenirken hata oluştu!', 'danger');
    } finally {
      setColorLoading(false);
    }
  };

  const handleColorEdit = async () => {
    try {
      setColorLoading(true);
      
      await api.put(`/admin/colors/${selectedColor.id}`, colorFormData);
      
      showToast('Renk başarıyla güncellendi!', 'success');
      setSelectedColor(null);
      setColorFormData({
        name: '',
        code: '',
        is_active: true
      });
      
      // Refresh colors list
      await fetchColors();
      
      // Also refresh phone model colors to ensure UI is up to date
      setTimeout(() => {
        fetchPhoneModelColors();
      }, 500);
      
    } catch (error) {
      console.error('Error updating color:', error);
      showToast('Renk güncellenirken hata oluştu!', 'danger');
    } finally {
      setColorLoading(false);
    }
  };

  const handleColorDelete = async (colorId) => {
    setConfirmModal({
      show: true,
      title: 'Renk Silme',
      message: 'Bu rengi silmek istediğinizden emin misiniz?',
      onConfirm: async () => {
        try {
          setButtonLoading(prev => ({ ...prev, [`delete_color_${colorId}`]: true }));
          
          await api.delete(`/admin/colors/${colorId}`);
          
          showToast('Renk başarıyla silindi!', 'success');
          
          // Refresh colors list
          await fetchColors();
          
          // Also refresh phone model colors to ensure UI is up to date
          setTimeout(() => {
      fetchPhoneModelColors();
          }, 500);
          
    } catch (error) {
          console.error('Error deleting color:', error);
          showToast('Renk silinirken hata oluştu!', 'danger');
    } finally {
          setButtonLoading(prev => ({ ...prev, [`delete_color_${colorId}`]: false }));
        }
      }
    });
  };

  const handlePhoneModelColorAdd = async (phoneModelId, colorId, stock = 0) => {
    try {
      // Ürün tipi seçilmemişse uyarı ver
      if (!selectedProductTypeForColors) {
        showToast('Lütfen önce bir ürün tipi seçin!', 'warning');
        return;
      }

      setAddingColor(true);
      
      await api.post('/admin/phone-model-colors', {
        phone_model_id: phoneModelId,
        color_id: colorId,
        product_type_id: selectedProductTypeForColors,
        stock: stock,
        is_active: true
      });
      
      showToast('Renk modele başarıyla eklendi!', 'success');
      
      // Close modal and refresh
      setShowStockModal(false);
      await fetchPhoneModelColors();
      
    } catch (error) {
      console.error('Error adding color to phone model:', error);
      showToast('Renk modele eklenirken hata oluştu!', 'danger');
    } finally {
      setAddingColor(false);
    }
  };

  const handleStockModalConfirm = () => {
    const { phoneModelId, colorId, stock } = stockModalData;
    handlePhoneModelColorAdd(phoneModelId, colorId, stock);
  };

  const handleStockModalCancel = () => {
    setShowStockModal(false);
    setStockModalData({
      phoneModelId: null,
      colorId: null,
      phoneModelName: '',
      colorName: '',
      colorCode: '',
      stock: 0
    });
  };

  const handlePhoneModelColorToggle = async (relationId, isActive) => {
    try {
      setButtonLoading(prev => ({ ...prev, [`toggle_relation_${relationId}`]: true }));
      
      await api.put(`/admin/phone-model-colors/${relationId}`, {
        is_active: !isActive
      });
      
      showToast(`Renk ${!isActive ? 'aktifleştirildi' : 'devre dışı bırakıldı'}!`, 'success');
      
      // Refresh phone model colors
      await fetchPhoneModelColors();
      
    } catch (error) {
      console.error('Error toggling phone model color:', error);
      showToast('Renk durumu değiştirilirken hata oluştu!', 'danger');
    } finally {
      setButtonLoading(prev => ({ ...prev, [`toggle_relation_${relationId}`]: false }));
    }
  };

  const handlePhoneModelColorDelete = async (relationId) => {
    setConfirmModal({
      show: true,
      title: 'Renk İlişkisi Silme',
      message: 'Bu renk ilişkisini silmek istediğinizden emin misiniz?',
      onConfirm: async () => {
        try {
          setButtonLoading(prev => ({ ...prev, [`delete_relation_${relationId}`]: true }));
          
          await api.delete(`/admin/phone-model-colors/${relationId}`);
          
          showToast('Renk ilişkisi başarıyla silindi!', 'success');
          
          // Refresh phone model colors
          await fetchPhoneModelColors();
          
    } catch (error) {
          console.error('Error deleting phone model color relation:', error);
          showToast('Renk ilişkisi silinirken hata oluştu!', 'danger');
        } finally {
          setButtonLoading(prev => ({ ...prev, [`delete_relation_${relationId}`]: false }));
        }
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let imagePath = formData.images;
      let noMaskImagePath = formData.no_mask;

      if (imageFile) {
        imagePath = await handleImageUpload(imageFile);
      }
      
      if (noMaskImageFile) {
        noMaskImagePath = await handleNoMaskImageUpload(noMaskImageFile);
      }
      
      // Yeni ürün detay görsellerini yükle
      let updatedProductDetailsImages = [...productDetailsImages];
      if (productDetailsImageFiles.length > 0) {
        const newImageUrls = await handleProductDetailsImageUpload(productDetailsImageFiles);
        
        // Yeni yüklenen görselleri mevcut görsellerle birleştir
        updatedProductDetailsImages = [...productDetailsImages.filter(img => !img.startsWith('blob:')), ...newImageUrls];
      }

      const isEdit = modalType.startsWith('edit_');
      const type = modalType.replace(isEdit ? 'edit_' : 'add_', '');
      const method = isEdit ? 'put' : 'post';
      
      let url;
      if (type === 'custom-products') {
        url = isEdit ? `/admin/custom-products/${selectedItem.id}` : `/admin/custom-products`;
      } else {
        url = isEdit 
          ? `/admin/${type === 'phone_models' ? 'phone-models' : type}/${selectedItem.id}`
          : `/admin/${type === 'phone_models' ? 'phone-models' : type}`;
      }

      let submitData;
      if (type === 'custom-products') {
        submitData = {
          name: formData.name,
          price: Number(formData.price),
          description: formData.description,
          is_active: formData.is_active,
          // Müşteri onayı durumu düzenleme formundan kaldırıldı, mevcut değeri koruyoruz
          is_approval: selectedItem ? selectedItem.is_approval : false,
          product_type_id: formData.product_type_id ? Number(formData.product_type_id) : null,
          phone_models: selectedModels.map(id => Number(id)),
          // Ürün detay görsellerini ekle
          product_details_images: updatedProductDetailsImages
        };
      } else if (type === 'products') {
        submitData = {
          name: formData.name,
          price: Number(formData.price),
          images: imagePath,
          no_mask: noMaskImagePath,
          description: formData.description,
          collection_id: formData.collection_id ? Number(formData.collection_id) : null,
          product_type_id: formData.product_type_id ? Number(formData.product_type_id) : null,
          phone_models: selectedModels.map(id => Number(id)),
          is_active: formData.is_active,
          // Ürün detay görsellerini ekle
          product_details_images: updatedProductDetailsImages
        };
      } else if (type === 'collections') {
        submitData = {
          name: formData.name,
          description: formData.description,
          image: imagePath
        };
      } else if (type === 'phone_models') {
        submitData = {
          brand: formData.brand,
          model_name: formData.model_name,
          is_active: formData.is_active
        };
      } else if (type === 'design_library') {
        submitData = {
          name: formData.name,
          description: formData.description,
          category: formData.category,
          image_url: imagePath,
          display_order: Number(formData.display_order),
          is_active: formData.is_active
        };
      } else if (type === 'colors') {
        submitData = {
          name: formData.name,
          code: formData.code,
          is_active: formData.is_active
        };
      } else {
        submitData = formData;
      }

      const response = await api[method](url, submitData);

      showToast(`${isEdit ? 'Güncelleme' : 'Ekleme'} işlemi başarılı!`, 'success');
      setShowModal(false);

      if (type === 'collections') {
        fetchCollections();
      } else if (type === 'products') {
        fetchProducts();
      } else if (type === 'phone_models') {
        fetchPhoneModels();
        // Also refresh phone model colors when a phone model is added or edited
        setTimeout(() => {
          fetchPhoneModelColors();
        }, 500);
      } else if (type === 'design_library') {
        fetchDesignLibrary();
      } else if (type === 'custom-products') {
        fetchCustomProducts();
      } else if (type === 'colors') {
        fetchColors();
        // Also refresh phone model colors when a color is added or edited
        setTimeout(() => {
          fetchPhoneModelColors();
        }, 500);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      showToast('İşlem başarısız oldu!', 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Ürün tipi seçildiğinde telefon modellerini yeniden çek
    if (name === 'product_type_id' && value) {
      fetchPhoneModels(value);
      // Mevcut telefon modeli seçimlerini temizle
      setSelectedModels([]);
    } else if (name === 'product_type_id' && !value) {
      // Ürün tipi temizlendiğinde tüm telefon modellerini göster
      fetchPhoneModels();
      setSelectedModels([]);
    }
  };

  const handleAddNew = (type) => {
    setModalType(`add_${type}`);
    setSelectedItem(null);
    setFormData({
      name: '',
      price: '',
      collection: '',
      phone_model: '',
      description: '',
      is_active: true,
      is_approval: true,
      product_type_id: ''
    });
    setShowModal(true);
  };

  const handleShowModal = (type, item = null) => {
    if (item) {
      setModalType(`edit_${type}`);
      setSelectedItem(item);
      setFormData(item);
    } else {
      setModalType(`add_${type}`);
      setSelectedItem(null);
        setFormData({
          name: '',
          price: '',
          collection: '',
        phone_model: '',
          description: '',
          is_active: true,
          is_approval: true
        });
    }
    setShowModal(true);
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { variant: 'warning', text: 'Beklemede' },
      'processing': { variant: 'info', text: 'İşleniyor' },
      'completed': { variant: 'success', text: 'Tamamlandı' },
      'failed': { variant: 'danger', text: 'Başarısız' }
    };
    
    const statusInfo = statusMap[status] || { variant: 'secondary', text: status };
    return <Badge bg={statusInfo.variant}>{statusInfo.text}</Badge>;
  };

  const getPaymentStatusBadge = (status) => {
    const statusMap = {
      'pending': { variant: 'warning', text: 'Beklemede' },
      'success': { variant: 'success', text: 'Başarılı' },
      'failed': { variant: 'danger', text: 'Başarısız' }
    };
    
    const statusInfo = statusMap[status] || { variant: 'secondary', text: status };
    return <Badge bg={statusInfo.variant}>{statusInfo.text}</Badge>;
  };

  const getPaymentMethodBadge = (paymentMethod) => {
    const methodMap = {
      'credit_card': { variant: 'primary', text: '💳 Kredi Kartı', icon: '💳' },
      'cash_on_delivery': { variant: 'success', text: '💰 Kapıda Nakit', icon: '💰' },
      'cashOnDelivery': { variant: 'success', text: '💰 Kapıda Nakit', icon: '💰' },
      'kapıda_ödeme': { variant: 'success', text: '💰 Kapıda Nakit', icon: '💰' },
      'kapida_odeme': { variant: 'success', text: '💰 Kapıda Nakit', icon: '💰' }
    };
    
    const methodInfo = methodMap[paymentMethod] || { variant: 'secondary', text: paymentMethod || 'Belirsiz', icon: '❓' };
    return <Badge bg={methodInfo.variant}>{methodInfo.text}</Badge>;
  };

  const handleShowOrderDetails = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const handleUpdateOrderStatus = async (orderId, newStatus) => {
    try {
      setUpdatingOrderStatus(true);
      
      await api.patch(`/admin/orders/${orderId}/status`, { 
        status: newStatus 
      });

      await fetchOrders();
      
      if (selectedOrder?.id === orderId) {
        setSelectedOrder(prev => ({ ...prev, status: newStatus }));
      }

      showToast('Sipariş durumu güncellendi!', 'success');
    } catch (error) {
      showToast('Sipariş durumu güncellenemedi!', 'danger');
    } finally {
      setUpdatingOrderStatus(false);
    }
  };

  // Kapıda ödeme siparişleri için ödeme durumu güncelleme
  const handleUpdatePaymentStatus = async (orderId, newPaymentStatus) => {
    try {
      setUpdatingOrderStatus(true);
      
      const response = await api.patch(`/admin/orders/${orderId}/payment-status`, { 
        payment_status: newPaymentStatus 
      });

      await fetchOrders();
      
      if (selectedOrder?.id === orderId) {
        setSelectedOrder(prev => ({ 
          ...prev, 
          payment_status: newPaymentStatus,
          status: response.data.order.status // Sipariş durumu da güncellenmiş olabilir
        }));
      }

      showToast('Ödeme durumu güncellendi!', 'success');
    } catch (error) {
      console.error('Payment status update error:', error);
      const errorMessage = error.response?.data?.error || 'Ödeme durumu güncellenemedi!';
      showToast(errorMessage, 'danger');
    } finally {
      setUpdatingOrderStatus(false);
    }
  };

  // Sipariş silme fonksiyonları
  const handleDeleteOrder = (order) => {
    setOrderToDelete(order);
    setShowDeleteOrderModal(true);
  };

  const handleConfirmDeleteOrder = async () => {
    if (!orderToDelete) return;

    try {
      setDeletingOrder(true);
      
      await api.delete(`/admin/orders/${orderToDelete.id}`);

      // Sipariş listesini yenile
      await fetchOrders();
      
      // Modal'ları kapat
      setShowDeleteOrderModal(false);
      setShowOrderModal(false);
      setOrderToDelete(null);
      setSelectedOrder(null);

      showToast('Sipariş başarıyla silindi!', 'success');
    } catch (error) {
      console.error('Order delete error:', error);
      const errorMessage = error.response?.data?.error || 'Sipariş silinemedi!';
      showToast(errorMessage, 'danger');
    } finally {
      setDeletingOrder(false);
    }
  };

  const handleCancelDeleteOrder = () => {
    setShowDeleteOrderModal(false);
    setOrderToDelete(null);
  };

  // Cache Management Functions
  const fetchCacheStats = async () => {
    try {
      setLoadingCache(true);
      const [statsResponse, healthResponse] = await Promise.all([
        api.get('/admin/cache-stats'),
        api.get('/admin/cache-health')
      ]);
      
      setCacheStats(statsResponse.data);
      setCacheHealth(healthResponse.data);
    } catch (error) {
      console.error('Cache stats fetch error:', error);
      showToast('Cache bilgileri yüklenemedi!', 'danger');
    } finally {
      setLoadingCache(false);
    }
  };

  const handleClearCache = async (pattern, withDependencies = false) => {
    try {
      setClearingCache(true);
      
      const endpoint = withDependencies 
        ? `/admin/cache-clear-deps/${pattern}`
        : `/admin/cache-clear/${pattern}`;
      
      const response = await api.post(endpoint);
      
      showToast(`Cache temizlendi: ${response.data.clearedKeys?.length || 0} key`, 'success');
      
      // Stats'ları yenile
      await fetchCacheStats();
    } catch (error) {
      console.error('Cache clear error:', error);
      showToast('Cache temizlenemedi!', 'danger');
    } finally {
      setClearingCache(false);
    }
  };

  const handleEmergencyCleanup = async () => {
    try {
      setClearingCache(true);
      await api.post('/admin/cache-emergency-cleanup');
      showToast('Acil durum temizliği tamamlandı!', 'success');
      await fetchCacheStats();
    } catch (error) {
      console.error('Emergency cleanup error:', error);
      showToast('Acil durum temizliği başarısız!', 'danger');
    } finally {
      setClearingCache(false);
    }
  };

  const handlePrintLabel = async (order) => {
    // Farklı payment_method formatlarını kontrol et
    const isCashOnDelivery = order.payment_method === 'cashOnDelivery' || 
                             order.payment_method === 'cash_on_delivery' ||
                             order.payment_method === 'kapıda_ödeme' ||
                             order.payment_method === 'kapida_odeme';
    
    if (!isCashOnDelivery) {
      showToast(`Bu sipariş kapıda ödeme siparişi değil! Ödeme türü: ${order.payment_method}`, 'warning');
      return;
    }

    if (!order.shipment?.barcode) {
      showToast('Bu sipariş için barcode bilgisi bulunamadı!', 'warning');
      return;
    }

    try {
      setPrintingLabel(true);
      setPrintingOrderId(order.id);
      
      showToast('Etiket oluşturuluyor...', 'info');

      const response = await api.post(`/admin/orders/${order.id}/print-label`);
      
      if (response.data.success) {
        // PDF base64 verisini blob'a çevir ve aç
        if (response.data.pdf) {
          // Base64'ü binary'ye çevir
          const binaryString = atob(response.data.pdf);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          
          // PDF blob oluştur
          const blob = new Blob([bytes], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          
          // Mobil cihaz kontrolü
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
          
          if (isMobile) {
            // Mobil: PDF'i indirme olarak başlat + modal göster
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `etiket-${order.order_number}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // PDF modal'ını da göster (görüntüleme için)
            setPdfModal({
              show: true,
              url: blobUrl,
              orderNumber: order.order_number
            });
            
            showToast(`${order.order_number} numaralı sipariş etiketi indirildi! Modal'da da görüntüleyebilirsiniz.`, 'success');
          } else {
            // Desktop: Yeni sekmede aç
            const newWindow = window.open(blobUrl, '_blank');
            
            if (!newWindow) {
              // Popup engellenirse indirme yöntemi kullan
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = `etiket-${order.order_number}.pdf`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              
              showToast(`Popup engellendi! ${order.order_number} numaralı sipariş etiketi indirildi.`, 'warning');
            } else {
              showToast(`${order.order_number} numaralı sipariş için etiket başarıyla oluşturuldu!`, 'success');
            }
          }
          
          // Memory leak'i önlemek için blob URL'ini temizle
          setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
        } else {
          // Fallback: Backend URL'ini kullan
          const pdfUrl = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/admin/orders/${order.id}/label-pdf`;
          window.open(pdfUrl, '_blank');
          showToast(`${order.order_number} numaralı sipariş için etiket başarıyla oluşturuldu!`, 'success');
        }
      } else {
        showToast('Etiket oluşturulamadı: ' + (response.data.error || 'Bilinmeyen hata'), 'danger');
      }
    } catch (error) {
      console.error('Etiket yazdırma hatası:', error);
      
      const errorMessage = error.response?.data?.error || 
                           error.response?.data?.details || 
                           'Etiket yazdırma sırasında bir hata oluştu';
      
      showToast(errorMessage, 'danger');
    } finally {
      setPrintingLabel(false);
      setPrintingOrderId(null);
    }
  };



  const filteredDesignLibrary = designLibrary.filter(design =>
    design.name.toLowerCase().includes(designLibrarySearchTerm.toLowerCase()) ||
    design.description?.toLowerCase().includes(designLibrarySearchTerm.toLowerCase()) ||
    design.category?.toLowerCase().includes(designLibrarySearchTerm.toLowerCase())
  );

  const filteredCustomProducts = customProductSearchTerm
    ? customProductsList.filter(product =>
        product.name.toLowerCase().includes(customProductSearchTerm.toLowerCase())
      )
    : customProductsList;

  const filteredColors = colorSearchTerm
    ? colors.filter(color =>
        color.name.toLowerCase().includes(colorSearchTerm.toLowerCase()) ||
        color.code.toLowerCase().includes(colorSearchTerm.toLowerCase())
      )
    : colors;

  // Handle template image upload
  const handleUploadTemplateImage = (modelId, brand, modelName, isTemplate) => {
    setTemplateUploadModal({
      show: true,
      modelId,
      modelName: `${brand} ${modelName}`,
      isTemplate
    });
    setTemplateImageFile(null);
    setTemplateImagePreview(null);
  };

  // Handle template image file selection
  const handleTemplateImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setTemplateImageFile(file);
    
    const reader = new FileReader();
    reader.onload = (e) => {
      setTemplateImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  // Upload template image
  const uploadTemplateImage = async () => {
    if (!templateImageFile || !templateUploadModal.modelId) return;
    
    setUploadingTemplate(true);
    
    try {
      const formData = new FormData();
      formData.append('file', templateImageFile);
      formData.append('modelName', templateUploadModal.modelName.replace(/\s+/g, '_'));
      formData.append('isTemplate', templateUploadModal.isTemplate);
      
      const response = await api.post('/phone-templates/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const imageUrl = response.data.url;
      
      // Update or create template in database
      const existingTemplate = phoneTemplates.find(
        t => t.phone_models?.id === templateUploadModal.modelId
      );
      
      if (existingTemplate) {
        // Update existing template
        const updateData = templateUploadModal.isTemplate
          ? { template_url: imageUrl }
          : { mask_url: imageUrl };
          
        await api.put(`/phone-templates/${existingTemplate.id}`, updateData);
      } else {
        // Create new template
        const templateData = {
          model_id: templateUploadModal.modelId,
          template_url: templateUploadModal.isTemplate ? imageUrl : '',
          mask_url: templateUploadModal.isTemplate ? '' : imageUrl
        };
        
        await api.post('/phone-templates', templateData);
      }
      
      // Refresh templates
      await fetchPhoneTemplates();
      
      showToast('Görsel başarıyla yüklendi!', 'success');
      setTemplateUploadModal({ ...templateUploadModal, show: false });
    } catch (error) {
      console.error('Görsel yüklenirken hata:', error);
      showToast('Görsel yüklenirken bir hata oluştu!', 'danger');
    } finally {
      setUploadingTemplate(false);
    }
  };

  // Telefon şablonu görselini kaldırma işlemi
  const handleRemoveTemplateImage = async (templateId, isTemplate) => {
    setConfirmModal({
      show: true,
      title: 'Görsel Silme',
      message: `Bu ${isTemplate ? 'referans' : 'maske'} görselini silmek istediğinizden emin misiniz?`,
      onConfirm: async () => {
        try {
          setButtonLoading(prev => ({ ...prev, [`remove_image_${templateId}`]: true }));
          
          // Görsel URL'sini boş string olarak güncelle
          const updateData = isTemplate 
            ? { template_url: '' } 
            : { mask_url: '' };
          
          await api.put(`/phone-templates/${templateId}`, updateData);
          
          // Şablonları yenile
          await fetchPhoneTemplates();
          
          showToast(`${isTemplate ? 'Referans' : 'Maske'} görseli başarıyla kaldırıldı!`, 'success');
        } catch (error) {
          console.error('Error removing template image:', error);
          showToast('Görsel kaldırılırken hata oluştu!', 'danger');
        } finally {
          setButtonLoading(prev => ({ ...prev, [`remove_image_${templateId}`]: false }));
        }
      }
    });
  };

  // WebP desteğini kontrol et
  const isWebPSupported = () => {
    const canvas = document.createElement('canvas');
    if (!canvas.toDataURL) {
      return false;
    }
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  };

  // Görsel indirme fonksiyonu
  const handleDownloadImage = async (imageUrl, fileName) => {
    try {
      // Görseli fetch ile al
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      
      // Blob'un gerçek MIME tipini al
      const mimeType = blob.type;
      console.log('Görsel MIME tipi:', mimeType); // Debug için
      
      // Görsel tipini kontrol et
      const isWebP = mimeType === 'image/webp' || imageUrl.includes('.webp') || imageUrl.includes('data:image/webp');
      
      // WebP desteğini kontrol et
      const webpSupported = isWebPSupported();
      console.log('WebP desteği:', webpSupported); // Debug için
      
      // Dosya adını ayarla
      let finalFileName = fileName;
      
      // Eğer görsel WebP ise ve dosya adı PNG ile bitiyorsa, uzantıyı değiştir
      if (isWebP && fileName.endsWith('.png')) {
        finalFileName = fileName.replace('.png', '.webp');
      }
      
      // Eğer görsel WebP değilse veya tarayıcı WebP desteklemiyorsa ve dosya adı WebP ile bitiyorsa, uzantıyı PNG yap
      if ((!isWebP || !webpSupported) && fileName.endsWith('.webp')) {
        finalFileName = fileName.replace('.webp', '.png');
      }
      
      console.log('Dosya adı:', finalFileName); // Debug için
      
      // Eğer görsel WebP ise ve tarayıcı destekliyorsa, doğrudan indir
      if (isWebP && webpSupported) {
        // Blob'dan URL oluştur
        const blobUrl = window.URL.createObjectURL(blob);
        
        // İndirme bağlantısı oluştur
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = finalFileName;
        document.body.appendChild(link);
        
        // İndirme işlemini başlat
        link.click();
        
        // Temizlik
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } 
      // Eğer görsel WebP ise ama tarayıcı desteklemiyorsa, PNG'ye dönüştür
      else if (isWebP && !webpSupported) {
        // WebP'yi PNG'ye dönüştür
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          
          // PNG olarak dışa aktar
          const pngDataUrl = canvas.toDataURL('image/png');
          
          // İndirme bağlantısı oluştur
          const link = document.createElement('a');
          link.href = pngDataUrl;
          link.download = finalFileName.replace('.webp', '.png');
          document.body.appendChild(link);
          
          // İndirme işlemini başlat
          link.click();
          
          // Temizlik
          document.body.removeChild(link);
        };
        img.onerror = () => {
          console.error('Görsel dönüştürme hatası');
          toast.error('Görsel dönüştürülürken bir hata oluştu');
        };
        img.src = URL.createObjectURL(blob);
      }
      // Diğer durumlarda doğrudan indir
      else {
        // Blob'dan URL oluştur
        const blobUrl = window.URL.createObjectURL(blob);
        
        // İndirme bağlantısı oluştur
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = finalFileName;
        document.body.appendChild(link);
        
        // İndirme işlemini başlat
        link.click();
        
        // Temizlik
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.error('Görsel indirme hatası:', error);
      toast.error('Görsel indirilirken bir hata oluştu');
    }
  };

  // Modal kapatma fonksiyonunu ekleyelim
  const handleCloseModal = () => {
    setShowModal(false);
    // Resim seçimlerini sıfırla
    setImageFile(null);
    setImagePreview(null);
    setNoMaskImageFile(null);
    setNoMaskImagePreview(null);
  };

  // Ürün detay görselleri için yeni fonksiyon ekleyelim
  const handleProductDetailsImageUpload = async (files) => {
    if (!files || files.length === 0) return [];
    
    const uploadedUrls = [];
    for (const file of files) {
      try {
        const formData = new FormData();
        formData.append('image', file);
        
        const response = await api.post('/admin/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        uploadedUrls.push(response.data.imageUrl);
      } catch (error) {
        console.error('Ürün detay görseli yükleme hatası:', error);
        showToast('Ürün detay görseli yüklenirken hata oluştu!', 'danger');
      }
    }
    
    return uploadedUrls;
  };
  
  const handleRemoveProductDetailsImage = (index) => {
    // Mevcut state'leri kopyalayalım
    const newPreviews = [...productDetailsImagePreviews];
    const newFiles = [...productDetailsImageFiles];
    const newImages = [...productDetailsImages];
    
    // İlgili öğeyi kaldıralım
    newPreviews.splice(index, 1);
    newFiles.splice(index, 1);
    newImages.splice(index, 1);
    
    // State'leri güncelleyelim
    setProductDetailsImagePreviews(newPreviews);
    setProductDetailsImageFiles(newFiles);
    setProductDetailsImages(newImages);
  };

  // Ürün detay görselleri için dosya değişiklik işleyicisi
  const handleProductDetailsImagesChange = (e) => {
    const files = Array.from(e.target.files);
    setProductDetailsImageFiles(prevFiles => [...prevFiles, ...files]);
    
    // Dosya önizlemelerini oluştur
    const newPreviews = files.map(file => URL.createObjectURL(file));
    setProductDetailsImagePreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
  };

  // Ürün detay görselini önizlemeden kaldır
  const removeProductDetailsImagePreview = (index) => {
    setProductDetailsImagePreviews(prevPreviews => 
      prevPreviews.filter((_, i) => i !== index)
    );
    setProductDetailsImageFiles(prevFiles => 
      prevFiles.filter((_, i) => i !== index)
    );
  };

  // API Logları sekmesi kaldırıldı

  return (
    <div className="admin-panel page-transition">
      <Container className="admin-panel">
        <h2 className="mb-4">Admin Panel</h2>

        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="tabs" className="mb-3">
            <Nav.Item>
              <Nav.Link eventKey="products">Ürünler</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="featured">Öne Çıkanlar</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="custom-designs">Müşteri Tasarımları</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="collections">Koleksiyonlar</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="phone-models">Telefon Modelleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="phone-templates">Telefon Şablonları</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="design-library">Hazır Tasarım Öğeleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="colors">Renkler</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="phone-model-colors">Telefon Modeli Renkleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="stock-manager">Stok Yönetimi</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="orders">Siparişler</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="returns">İade Talepleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="asset-manager">Asset Görselleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="cache-manager">Cache Yönetimi</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="product-types">Ürün Tipleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="parameters">Sistem Parametreleri</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="analytics">Analitik Dashboard</Nav.Link>
            </Nav.Item>
            {/* API Logları sekmesi kaldırıldı */}
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="products">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Ürün ara..."
                  value={productSearchTerm}
                  onChange={(e) => setProductSearchTerm(e.target.value)}
                  className="w-auto"
                />
                <Button variant="primary" onClick={() => handleAdd('products')}>
                  Yeni Ürün Ekle
                </Button>
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th style={{ width: '50px' }}>ID</th>
                    <th style={{ width: '80px' }}>Resim</th>
                    <th style={{ width: '80px' }}>Maskesiz</th>
                    <th style={{ width: '120px' }}>Ürün Detay Görselleri</th>
                    <th style={{ width: '15%' }}>Ad</th>
                    <th style={{ width: '80px' }}>Fiyat</th>
                    <th style={{ width: '15%' }}>Koleksiyon</th>
                    <th style={{ width: '15%' }}>Ürün Tipi</th>
                    <th style={{ width: '200px' }}>Telefon Modelleri</th>
                    <th style={{ width: '120px' }}>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProducts.map((product) => (
                    <tr key={product.id}>
                      <td>{product.id}</td>
                      <td>
                        <div style={{ 
                          width: '70px', 
                          height: '70px', 
                          borderRadius: '4px',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f8f9fa',
                          cursor: 'pointer',
                          border: '1px solid #dee2e6'
                        }}
                        onClick={() => handleImagePreview(product.images)}
                        >
                          <img
                            src={product.images}
                            alt={product.name}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        <Button 
                          variant="link" 
                          size="sm" 
                          className="mt-1"
                          onClick={() => handleDownloadImage(product.images, `tasarim_${product.id}.webp`)}
                        >
                          İndir
                        </Button>
                      </td>
                      <td>
                        <div style={{ 
                          width: '70px', 
                          height: '70px', 
                          borderRadius: '4px',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f8f9fa',
                          cursor: product.no_mask ? 'pointer' : 'default',
                          border: '1px solid #dee2e6'
                        }}
                        onClick={() => product.no_mask && handleImagePreview(product.no_mask)}
                        >
                          <img
                            src={product.no_mask}
                            alt="Maskesiz Görsel"
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        {product.no_mask && (
                          <Button 
                            variant="link" 
                            size="sm" 
                            className="mt-1"
                            onClick={() => handleDownloadImage(product.no_mask, `maskesiz_${product.id}.webp`)}
                          >
                            İndir
                          </Button>
                        )}
                      </td>
                      <td>
                        <div className="product-details-images-container">
                          {product.product_details_images && Array.isArray(product.product_details_images) && product.product_details_images.length > 0 ? (
                            <div className="d-flex flex-wrap gap-2">
                              {product.product_details_images.slice(0, 3).map((imageUrl, index) => (
                                <div 
                                  key={index}
                                  style={{ 
                                    width: '50px', 
                                    height: '50px', 
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f8f9fa',
                                    cursor: 'pointer',
                                    border: '1px solid #dee2e6'
                                  }}
                                  onClick={() => handleImagePreview(imageUrl)}
                                >
                                  <img
                                    src={imageUrl}
                                    alt={`Detay Görsel ${index + 1}`}
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain'
                                    }}
                                    onError={handleImageError}
                                  />
                                </div>
                              ))}
                              {product.product_details_images.length > 3 && (
                                <div 
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f0f0f0',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                  }}
                                  onClick={() => {
                                    setImagePreviewGallery(product.product_details_images);
                                    setShowImageGallery(true);
                                  }}
                                >
                                  +{product.product_details_images.length - 3}
                                </div>
                              )}
                            </div>
                          ) : (
                            <span className="text-muted">Detay görsel yok</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <ExpandableCell 
                          content={product.name} 
                          cellId={`product_name_${product.id}`} 
                        />
                      </td>
                      <td>{product.price} TL</td>
                      <td>{product.collection || '-'}</td>
                      <td>{product.product_types?.display_name || '-'}</td>
                      <td>
                        {product.phone_models ? (
                          <div 
                            className={`phone-models-cell ${expandedCells[`product_models_${product.id}`] ? 'expanded' : ''}`}
                            onClick={() => toggleCellExpansion(`product_models_${product.id}`)}
                            title={expandedCells[`product_models_${product.id}`] ? "Daraltmak için tıklayın" : "Genişletmek için tıklayın"}
                          >
                            {product.phone_models}
                          </div>
                        ) : 'Model Seçilmemiş'}
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEdit('products', {
                              ...product,
                              collection_id: product.collection_id
                            })}
                          >
                            <span className="button-icon">✏️</span> Düzenle
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete('products', product.id)}
                            disabled={buttonLoading[`delete_products_${product.id}`]}
                          >
                            {buttonLoading[`delete_products_${product.id}`] ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              <>
                                <span className="button-icon">🗑️</span> Sil
                              </>
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="featured">
              <FeaturedProducts />
            </Tab.Pane>
            
            <Tab.Pane eventKey="custom-designs">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Müşteri tasarımı ara..."
                  value={customProductSearchTerm}
                  onChange={(e) => setCustomProductSearchTerm(e.target.value)}
                  className="w-auto"
                />
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Resim</th>
                    <th>Maskeli</th>
                    <th>Maskesiz</th>
                    <th>Ad</th>
                    <th>Fiyat</th>
                    <th>Telefon Modeli</th>
                    <th>Durum</th>
                    <th>Müşteri Onayı</th>
                    <th style={{ width: '160px' }}>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomProducts.map((product) => (
                    <tr key={product.id}>
                      <td>{product.id}</td>
                      <td>
                        <div 
                          style={{ 
                            width: '70px', 
                            height: '70px', 
                            borderRadius: '4px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer',
                            border: '1px solid #dee2e6'
                          }}
                          onClick={() => handleImagePreview(product.images)}
                        >
                          <img
                            src={product.images}
                            alt={product.name}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        <Button 
                          variant="link" 
                          size="sm" 
                          className="mt-1"
                          onClick={() => handleDownloadImage(product.images, `tasarim_${product.id}.webp`)}
                        >
                          İndir
                        </Button>
                      </td>
                      <td>
                        <div 
                          style={{ 
                            width: '70px', 
                            height: '70px', 
                            borderRadius: '4px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f8f9fa',
                            cursor: product.mask_image ? 'pointer' : 'default',
                            border: '1px solid #dee2e6'
                          }}
                          onClick={() => product.mask_image && handleImagePreview(product.mask_image)}
                        >
                          <img
                            src={product.mask_image}
                            alt="Maskeli Görsel"
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        {product.mask_image && (
                          <Button 
                            variant="link" 
                            size="sm" 
                            className="mt-1"
                            onClick={() => handleDownloadImage(product.mask_image, `maskeli_${product.id}.webp`)}
                          >
                            İndir
                          </Button>
                        )}
                      </td>
                      <td>
                        <div 
                          style={{ 
                            width: '70px', 
                            height: '70px', 
                            borderRadius: '4px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f8f9fa',
                            cursor: product.no_mask ? 'pointer' : 'default',
                            border: '1px solid #dee2e6'
                          }}
                          onClick={() => product.no_mask && handleImagePreview(product.no_mask)}
                        >
                          <img
                            src={product.no_mask}
                            alt="Maskesiz Görsel"
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        {product.no_mask && (
                          <Button 
                            variant="link" 
                            size="sm" 
                            className="mt-1"
                            onClick={() => handleDownloadImage(product.no_mask, `maskesiz_${product.id}.webp`)}
                          >
                            İndir
                          </Button>
                        )}
                      </td>
                      <td>
                        <ExpandableCell 
                          content={product.name} 
                          cellId={`custom_product_name_${product.id}`} 
                        />
                      </td>
                      <td>{product.price} TL</td>
                      <td>
                        <ExpandableCell 
                          content={product.phone_models} 
                          cellId={`custom_product_models_${product.id}`} 
                        />
                      </td>
                      <td>
                        <Badge bg={product.is_active ? 'success' : 'danger'}>
                          {product.is_active ? 'Aktif' : 'Pasif'}
                        </Badge>
                      </td>
                      <td>
                        <Badge bg={product.is_approval ? 'success' : 'danger'}>
                          {product.is_approval ? 'Onaylandı' : 'Onaylanmadı'}
                        </Badge>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEdit('custom-products', {
                              ...product,
                              collection_id: product.collection_id
                            })}
                          >
                            <span className="button-icon">✏️</span> Düzenle
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete('custom-products', product.id)}
                            disabled={buttonLoading[`delete_custom_products_${product.id}`]}
                          >
                            {buttonLoading[`delete_custom_products_${product.id}`] ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              <>
                                <span className="button-icon">🗑️</span> Sil
                              </>
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="collections">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Koleksiyon ara..."
                  value={collectionSearchTerm}
                  onChange={(e) => setCollectionSearchTerm(e.target.value)}
                  className="w-auto"
                />
                <Button variant="primary" onClick={() => handleAdd('collections')}>
                  Yeni Koleksiyon Ekle
                </Button>
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Resim</th>
                    <th>Ad</th>
                    <th>Açıklama</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCollections.map((collection) => (
                    <tr key={collection.id}>
                      <td>{collection.id}</td>
                      <td>
                        <div 
                          style={{ 
                            width: '70px', 
                            height: '70px', 
                            borderRadius: '4px',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer',
                            border: '1px solid #dee2e6'
                          }}
                          onClick={() => handleImagePreview(collection.image)}
                        >
                          <img
                            src={collection.image}
                            alt={collection.name}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                      </td>
                      <td>
                        <ExpandableCell 
                          content={collection.name} 
                          cellId={`collection_name_${collection.id}`} 
                        />
                      </td>
                      <td>
                        <ExpandableCell 
                          content={collection.description || 'Açıklama yok'} 
                          cellId={`collection_desc_${collection.id}`} 
                        />
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEdit('collections', collection)}
                          >
                            <span className="button-icon">✏️</span> Düzenle
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete('collections', collection.id)}
                            disabled={buttonLoading[`delete_collections_${collection.id}`]}
                          >
                            {buttonLoading[`delete_collections_${collection.id}`] ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              <>
                                <span className="button-icon">🗑️</span> Sil
                              </>
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="phone-models">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Telefon modeli ara..."
                  value={phoneModelSearchTerm}
                  onChange={(e) => setPhoneModelSearchTerm(e.target.value)}
                  className="w-auto"
                />
                <Button variant="primary" onClick={() => handleAdd('phone_models')}>
                  Yeni Model Ekle
                </Button>
              </div>

              {Object.entries(filteredPhoneModels).map(([brand, models]) => (
                <div key={brand} className="mb-4">
                  <h5>{brand}</h5>
                  <Table responsive striped bordered hover>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Model</th>
                        <th>Durum</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {models.map((model) => (
                        <tr key={model.id}>
                          <td>{model.id}</td>
                          <td>
                            <ExpandableCell 
                              content={model.brand} 
                              cellId={`phone_model_brand_${model.id}`} 
                            />
                          </td>
                          <td>
                            <ExpandableCell 
                              content={model.model_name} 
                              cellId={`phone_model_name_${model.id}`} 
                            />
                          </td>
                          <td>
                            <div className="action-buttons">
                              <Button
                                variant="warning"
                                size="sm"
                                onClick={() => handleEdit('phone_models', model)}
                              >
                                <span className="button-icon">✏️</span> Düzenle
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleDelete('phone_models', model.id)}
                                disabled={buttonLoading[`delete_phone_models_${model.id}`]}
                              >
                                {buttonLoading[`delete_phone_models_${model.id}`] ? (
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <>
                                    <span className="button-icon">🗑️</span> Sil
                                  </>
                                )}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ))}
            </Tab.Pane>
            
            <Tab.Pane eventKey="phone-templates">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Şablon ara..."
                  value={phoneModelSearchTerm}
                  onChange={(e) => setPhoneModelSearchTerm(e.target.value)}
                  className="w-auto"
                />
              </div>
              
              <div className="phone-templates-container">
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </Spinner>
                  </div>
                ) : (
                  Object.entries(filteredPhoneModels).map(([brand, models]) => (
                    <div key={brand} className="mb-4">
                      <h4>{brand}</h4>
                      <div className="row g-3">
                        {models.map(model => {
                          const template = phoneTemplates.find(t => t.phone_models?.id === model.id);
                          return (
                            <div key={model.id} className="col-md-4 col-lg-3">
                              <div className="card h-100">
                                <div className="card-header">
                                  <h5 className="mb-0">{model.brand} {model.model_name}</h5>
                                </div>
                                <div className="card-body">
                                  <div className="row mb-3">
                                    <div className="col-12 text-center mb-2">
                                      <h6>Referans Görsel</h6>
                                      <div className="template-image-container">
                                        {template?.template_url ? (
                                          <div className="position-relative w-100 h-100">
                                            <img 
                                              src={template.template_url} 
                                              alt={`${model.brand} ${model.model_name} template`}
                                              className="img-fluid template-image"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleImagePreview(template.template_url);
                                              }}
                                              style={{ cursor: 'pointer' }}
                                            />
                                            <Button 
                                              variant="danger" 
                                              size="sm" 
                                              className="position-absolute top-0 end-0 m-2 delete-btn"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveTemplateImage(template.id, true);
                                              }}
                                            >
                                              <i className="fa fa-trash"></i> Sil
                                            </Button>
                                          </div>
                                        ) : (
                                          <div className="no-image-placeholder">
                                            <span>Görsel Yok</span>
                                          </div>
                                        )}
                                      </div>
                                      <Button 
                                        variant="outline-primary" 
                                        size="sm" 
                                        className="mt-2"
                                        onClick={() => handleUploadTemplateImage(model.id, model.brand, model.model_name, true)}
                                      >
                                        Referans Görsel Yükle
                                      </Button>
                                    </div>
                                    
                                    <div className="col-12 text-center mt-3">
                                      <h6>Maske Görsel</h6>
                                      <div className="template-image-container">
                                        {template?.mask_url ? (
                                          <div className="position-relative w-100 h-100">
                                            <img 
                                              src={template.mask_url} 
                                              alt={`${model.brand} ${model.model_name} mask`}
                                              className="img-fluid template-image"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleImagePreview(template.mask_url);
                                              }}
                                              style={{ cursor: 'pointer' }}
                                            />
                                            <Button 
                                              variant="danger" 
                                              size="sm" 
                                              className="position-absolute top-0 end-0 m-2 delete-btn"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemoveTemplateImage(template.id, false);
                                              }}
                                            >
                                              <i className="fa fa-trash"></i> Sil
                                            </Button>
                                          </div>
                                        ) : (
                                          <div className="no-image-placeholder">
                                            <span>Görsel Yok</span>
                                          </div>
                                        )}
                                      </div>
                                      <Button 
                                        variant="outline-primary" 
                                        size="sm" 
                                        className="mt-2"
                                        onClick={() => handleUploadTemplateImage(model.id, model.brand, model.model_name, false)}
                                      >
                                        Maske Görsel Yükle
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))
                )}
                
                {!loading && Object.keys(filteredPhoneModels).length === 0 && (
                  <div className="alert alert-info">
                    Arama kriterlerine uygun telefon modeli bulunamadı.
                  </div>
                )}
              </div>
            </Tab.Pane>
            
            <Tab.Pane eventKey="design-library">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Tasarım ara..."
                  value={designLibrarySearchTerm}
                  onChange={(e) => setDesignLibrarySearchTerm(e.target.value)}
                  className="w-auto"
                />
                <Button variant="primary" onClick={() => handleAdd('design_library')}>
                  Yeni Tasarım Ekle
                </Button>
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Görsel</th>
                    <th>Ad</th>
                    <th>Açıklama</th>
                    <th>Kategori</th>
                    <th>Sıralama</th>
                    <th>Durum</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDesignLibrary.map((design) => (
                    <tr key={design.id}>
                      <td>{design.id}</td>
                      <td>
                        <div style={{ 
                          width: '70px', 
                          height: '70px', 
                          borderRadius: '4px',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#f8f9fa'
                        }}>
                          <img
                            src={design.image_url}
                            alt={design.name}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '100%', 
                              objectFit: 'contain'
                            }}
                            onError={handleImageError}
                          />
                        </div>
                        </td>
                      <td>{design.name}</td>
                      <td>{design.description}</td>
                      <td>{design.category}</td>
                      <td>{design.display_order}</td>
                      <td>{design.is_active ? 'Aktif' : 'Pasif'}</td>
                        <td>
                          <div className="action-buttons">
                            <Button
                              variant="warning"
                              size="sm"
                            onClick={() => handleEdit('design_library', design)}
                            >
                              <span className="button-icon">✏️</span> Düzenle
                            </Button>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleDelete('design_library', design.id)}
                              disabled={buttonLoading[`delete_design_library_${design.id}`]}
                            >
                              {buttonLoading[`delete_design_library_${design.id}`] ? (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              ) : (
                                <>
                                  <span className="button-icon">🗑️</span> Sil
                                </>
                              )}
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="colors">
              <div className="d-flex justify-content-between mb-3">
                <Form.Control
                  type="text"
                  placeholder="Renk ara..."
                  value={colorSearchTerm}
                  onChange={(e) => setColorSearchTerm(e.target.value)}
                  className="w-auto"
                />
                <Button 
                  variant="primary" 
                  onClick={() => {
                    setSelectedColor(null);
                    setColorFormData({
                      name: '',
                      code: '',
                      is_active: true
                    });
                    setShowModal(true);
                    setModalType('add_colors');
                  }}
                >
                  Yeni Renk Ekle
                </Button>
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Renk</th>
                    <th>Ad</th>
                    <th>Kod</th>
                    <th>Durum</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredColors.map((color) => (
                    <tr key={color.id}>
                      <td>{color.id}</td>
                      <td>
                        <div 
                          className="color-preview"
                            style={{ 
                            backgroundColor: color.code,
                            width: '30px',
                            height: '30px',
                            borderRadius: '4px',
                            border: '1px solid #ddd'
                          }}
                        />
                      </td>
                      <td>{color.name}</td>
                      <td>
                        <span>{color.code}</span>
                      </td>
                      <td>
                        <Badge bg={color.is_active ? 'success' : 'danger'}>
                          {color.is_active ? 'Aktif' : 'Pasif'}
                        </Badge>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => {
                              setSelectedColor(color);
                              setColorFormData({
                                name: color.name,
                                code: color.code,
                                is_active: color.is_active
                              });
                              setModalType('edit_colors');
                              setShowModal(true);
                            }}
                          >
                            <span className="button-icon">✏️</span> Düzenle
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleColorDelete(color.id)}
                            disabled={colorLoading}
                          >
                            {colorLoading ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              <>
                                <span className="button-icon">🗑️</span> Sil
                              </>
                            )}
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="phone-model-colors">
              <div className="mb-4">
                <h5>Telefon Modeli Renkleri</h5>
                <p className="text-muted">
                  Telefon modellerine ürün tipine göre renk atayabilir, renkleri aktif/pasif yapabilir veya silebilirsiniz.
                </p>
                
                {/* Ürün Tipi Seçimi */}
                <div className="product-type-selector mb-4 p-3 border rounded bg-light">
                  <Row className="align-items-center">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">Ürün Tipi Seçin</Form.Label>
                        <Form.Select
                          value={selectedProductTypeForColors}
                          onChange={(e) => setSelectedProductTypeForColors(e.target.value)}
                          className="form-select-lg"
                        >
                          <option value="">-- Ürün Tipi Seçin --</option>
                          {productTypes.map(type => (
                            <option key={type.id} value={type.id}>
                              {type.display_name} ({type.name})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      {selectedProductTypeForColors && (
                        <div className="selected-type-info">
                          <Badge bg="primary" className="fs-6 p-2">
                            Seçili: {productTypes.find(t => t.id == selectedProductTypeForColors)?.display_name}
                          </Badge>
                          <p className="text-muted mt-2 mb-0">
                            {productTypes.find(t => t.id == selectedProductTypeForColors)?.description}
                          </p>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>

              {!selectedProductTypeForColors ? (
                <div className="text-center py-5">
                  <div className="text-muted">
                    <i className="fas fa-mobile-alt fa-3x mb-3"></i>
                    <h5>Ürün Tipi Seçin</h5>
                    <p>Telefon modeli renklerini yönetmek için önce bir ürün tipi seçin.</p>
                  </div>
                </div>
              ) : (
                <>
                  {Object.entries(filteredPhoneModels).map(([brand, models]) => (
                <div key={brand} className="mb-4">
                  <h5>{brand}</h5>
                  {models.map((model) => {
                    // Seçili ürün tipine göre renkleri filtrele
                    const allModelColors = phoneModelColorsMap[model.id] || [];
                    const modelColors = allModelColors.filter(relation => 
                      relation.product_type_id == selectedProductTypeForColors
                    );
                    return (
                      <div key={model.id} className="phone-model-colors-container mb-4 p-3 border rounded">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6>{model.model_name}</h6>
                          <Form.Select 
                            style={{ width: 'auto' }}
                            onChange={(e) => {
                              if (e.target.value) {
                                const selectedColor = colors.find(c => c.id == e.target.value);
                                setStockModalData({
                                  phoneModelId: model.id,
                                  colorId: e.target.value,
                                  phoneModelName: model.model_name,
                                  colorName: selectedColor.name,
                                  colorCode: selectedColor.code,
                                  stock: 10 // Default stock
                                });
                                setShowStockModal(true);
                                e.target.value = ''; // Reset after selection
                              }
                            }}
                          >
                            <option value="">Renk Ekle...</option>
                            {colors
                              .filter(color => 
                                // Seçili ürün tipi için bu modelde henüz eklenmeyen renkleri göster
                                !modelColors.some(relation => 
                                  relation && relation.product_colors && relation.product_colors.id === color.id
                                )
                              )
                              .map(color => (
                                <option key={color.id} value={color.id}>
                                  {color.name} ({color.code})
                                </option>
                              ))
                            }
                          </Form.Select>
                        </div>
                        
                        {modelColors.length > 0 ? (
                          <div className="color-chips-container d-flex flex-wrap gap-2">
                            {modelColors.map(relation => {
                              if (!relation || !relation.product_colors) return null;
                              const color = relation.product_colors;
                              return (
                                <div key={relation.id} className="color-chip p-2 border rounded d-flex align-items-center gap-2">
                                  <div 
                                    className="color-preview"
                                    style={{ 
                                      backgroundColor: color.code,
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}
                                  />
                                  <span className="color-name">{color.name}</span>
                                  <div className="color-actions d-flex gap-1">
                                    <Button
                                      variant={relation.is_active ? "outline-secondary" : "outline-success"}
                                      size="sm"
                                      onClick={() => handlePhoneModelColorToggle(relation.id, relation.is_active)}
                                      disabled={buttonLoading[`toggle_relation_${relation.id}`]}
                                    >
                                      {buttonLoading[`toggle_relation_${relation.id}`] ? (
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                      ) : relation.is_active ? (
                                        'Pasif Yap'
                                      ) : (
                                        'Aktif Yap'
                                      )}
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => handlePhoneModelColorDelete(relation.id)}
                                      disabled={buttonLoading[`delete_relation_${relation.id}`]}
                                    >
                                      {buttonLoading[`delete_relation_${relation.id}`] ? (
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                      ) : (
                                        'Sil'
                                      )}
                                    </Button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p className="text-muted">Bu model için henüz renk eklenmemiş.</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
                </>
              )}
            </Tab.Pane>
            
            <Tab.Pane eventKey="stock-manager">
              <StockManager />
            </Tab.Pane>
            
            <Tab.Pane eventKey="orders">
              <div className="filter-section mb-4 p-3 border rounded bg-light">
                <h5 className="mb-3">Sipariş Filtreleme</h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <Form.Control
                      type="text"
                      placeholder="Sipariş no, müşteri adı veya email ara..."
                      value={orderFilters.searchTerm}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, searchTerm: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-4">
                    <Form.Select
                      value={orderFilters.status}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, status: e.target.value }))}
                    >
                      <option value="">Sipariş Durumu (Tümü)</option>
                      <option value="pending">Beklemede</option>
                      <option value="processing">İşleniyor</option>
                      <option value="completed">Tamamlandı</option>
                      <option value="cancelled">İptal Edildi</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <Form.Select
                      value={orderFilters.paymentStatus}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, paymentStatus: e.target.value }))}
                    >
                      <option value="">Ödeme Durumu (Tümü)</option>
                      <option value="pending">Beklemede</option>
                      <option value="success">Başarılı</option>
                      <option value="failed">Başarısız</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-4">
                    <Form.Select
                      value={orderFilters.paymentMethod}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, paymentMethod: e.target.value }))}
                    >
                      <option value="">Ödeme Türü (Tümü)</option>
                      <option value="credit_card">💳 Kredi Kartı</option>
                      <option value="cash_on_delivery">💰 Kapıda Nakit</option>
                    </Form.Select>
                  </div>
                  <div className="col-md-3">
                    <Form.Control
                      type="date"
                      placeholder="Başlangıç tarihi"
                      value={orderFilters.startDate}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, startDate: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Control
                      type="date"
                      placeholder="Bitiş tarihi"
                      value={orderFilters.endDate}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, endDate: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Control
                      type="number"
                      placeholder="Min. Tutar"
                      value={orderFilters.minAmount}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, minAmount: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <Form.Control
                      type="number"
                      placeholder="Max. Tutar"
                      value={orderFilters.maxAmount}
                      onChange={(e) => setOrderFilters(prev => ({ ...prev, maxAmount: e.target.value }))}
                    />
                  </div>
                  <div className="col-12">
                    <Button 
                      variant="secondary" 
                      onClick={() => setOrderFilters({
                        searchTerm: '',
                        startDate: '',
                        endDate: '',
                        status: '',
                        paymentStatus: '',
                        paymentMethod: '',
                        minAmount: '',
                        maxAmount: ''
                      })}
                    >
                      Filtreleri Temizle
                    </Button>
                  </div>
                </div>
              </div>
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>Sipariş No</th>
                    <th>Müşteri</th>
                    <th>Tutar</th>
                    <th>Ödeme Türü</th>
                    <th>Sipariş Durumu</th>
                    <th>Ödeme Durumu</th>
                    <th>Renk</th>
                    <th>Barkod</th>
                    <th>Tarih</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((order) => (
                    <tr key={order.id}>
                      <td>{order.order_number}</td>
                      <td>
                        <ExpandableCell 
                          content={`${order.first_name} ${order.last_name}`} 
                          cellId={`order_customer_${order.id}`} 
                        />
                      </td>
                      <td>{order.total_amount} TL</td>
                      <td>{getPaymentMethodBadge(order.payment_method)}</td>
                      <td>{getStatusBadge(order.status)}</td>
                      <td>{getPaymentStatusBadge(order.payment_status)}</td>
                      <td>
                        {order.cart_items && order.cart_items[0]?.color_name ? order.cart_items[0].color_name : '-'}
                      </td>
                      <td>
                        {order.shipment?.barcode ? (
                          (() => {
                            const isCashOnDelivery = order.payment_method === 'cashOnDelivery' || 
                                                     order.payment_method === 'cash_on_delivery' ||
                                                     order.payment_method === 'kapıda_ödeme' ||
                                                     order.payment_method === 'kapida_odeme';
                            
                            return isCashOnDelivery ? (
                              <button 
                                className="btn btn-sm btn-outline-success"
                                onClick={() => handlePrintLabel(order)}
                                title="Kapıda ödeme etiketi yazdır"
                                disabled={printingLabel && printingOrderId === order.id}
                              >
                                {printingLabel && printingOrderId === order.id ? (
                                  <>⏳ Yazdırılıyor...</>
                                ) : (
                                  <>📄 {order.shipment.barcode}</>
                                )}
                              </button>
                            ) : (
                              <a 
                                href={order.shipment.label_url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                                title="Etiket görüntüle"
                              >
                                🔗 {order.shipment.barcode}
                              </a>
                            );
                          })()
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{new Date(order.created_at).toLocaleString('tr-TR')}</td>
                      <td>
                        <Button 
                          variant="info" 
                          size="sm" 
                          onClick={() => handleShowOrderDetails(order)}
                        >
                          Detaylar
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Tab.Pane>
            
            <Tab.Pane eventKey="returns">
              <ReturnRequestsAdmin />
            </Tab.Pane>

            <Tab.Pane eventKey="asset-manager">
              <AssetManager />
            </Tab.Pane>

            <Tab.Pane eventKey="product-types">
              <ProductTypesManager />
            </Tab.Pane>

            <Tab.Pane eventKey="parameters">
              <Parameters />
            </Tab.Pane>

            <Tab.Pane eventKey="analytics">
              <AnalyticsDashboard />
            </Tab.Pane>

            <Tab.Pane eventKey="cache-manager">
              <div className="cache-management">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4>🚀 Smart Cache Yönetimi</h4>
                  <Button 
                    variant="outline-primary" 
                    onClick={fetchCacheStats}
                    disabled={loadingCache}
                  >
                    {loadingCache ? '🔄 Yenileniyor...' : '🔄 Yenile'}
                  </Button>
                </div>

                {/* Cache Health Status */}
                {cacheHealth && (
                  <Alert variant={cacheHealth.status === 'healthy' ? 'success' : 'warning'} className="mb-4">
                    <Alert.Heading>
                      {cacheHealth.status === 'healthy' ? '✅ Cache Sistemi Sağlıklı' : '⚠️ Cache Sistemi Uyarısı'}
                    </Alert.Heading>
                    <p className="mb-0">
                      Hit Rate: <strong>{cacheHealth.hitRate}%</strong> | 
                      Memory: <strong>{cacheHealth.memoryUsage?.pressurePercentage || 'N/A'}</strong> | 
                      Keys: <strong>{cacheHealth.totalKeys}</strong>
                    </p>
                    {cacheHealth.recommendations && cacheHealth.recommendations.length > 0 && (
                      <div className="mt-2">
                        <strong>Öneriler:</strong>
                        <ul className="mb-0 mt-1">
                          {cacheHealth.recommendations.map((rec, index) => (
                            <li key={index}>{rec}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Alert>
                )}

                <Row>
                  {/* Cache Statistics */}
                  <Col md={6}>
                    <Card className="mb-4">
                      <Card.Header>📊 Cache İstatistikleri</Card.Header>
                      <Card.Body>
                        {cacheStats ? (
                          <div>
                            <div className="mb-3">
                              <div className="d-flex justify-content-between">
                                <span>Hit Rate:</span>
                                <Badge bg="success">{cacheStats.hitRate}%</Badge>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Total Hits:</span>
                                <span>{cacheStats.hits?.toLocaleString()}</span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Total Misses:</span>
                                <span>{cacheStats.misses?.toLocaleString()}</span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Total Keys:</span>
                                <span>{cacheStats.totalKeys}</span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Uptime:</span>
                                <span>{cacheStats.uptimeHours} hours</span>
                              </div>
                            </div>

                            {/* Memory Usage */}
                            <div className="mb-3">
                              <h6>💾 Memory Kullanımı</h6>
                              <div className="d-flex justify-content-between">
                                <span>Heap Used:</span>
                                <span>{cacheStats.memoryUsage?.heapUsed}</span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Heap Total:</span>
                                <span>{cacheStats.memoryUsage?.heapTotal}</span>
                              </div>
                              <div className="d-flex justify-content-between">
                                <span>Pressure:</span>
                                <Badge bg={
                                  parseFloat(cacheStats.memoryUsage?.pressurePercentage) < 70 ? 'success' :
                                  parseFloat(cacheStats.memoryUsage?.pressurePercentage) < 85 ? 'warning' : 'danger'
                                }>
                                  {cacheStats.memoryUsage?.pressurePercentage}
                                </Badge>
                              </div>
                            </div>

                            {/* Recent Cache Keys */}
                            {cacheStats.cacheKeys && cacheStats.cacheKeys.length > 0 && (
                              <div>
                                <h6>🔑 Son Cache Keys ({cacheStats.cacheKeys.length})</h6>
                                <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                                  {cacheStats.cacheKeys.slice(0, 10).map((key, index) => (
                                    <div key={index} style={{ fontSize: '0.8em', fontFamily: 'monospace' }}>
                                      {key}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="text-center">
                            <Button 
                              variant="primary" 
                              onClick={fetchCacheStats}
                              disabled={loadingCache}
                            >
                              {loadingCache ? 'Yükleniyor...' : 'Cache İstatistiklerini Yükle'}
                            </Button>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Cache Management Actions */}
                  <Col md={6}>
                    <Card className="mb-4">
                      <Card.Header>🛠️ Cache İşlemleri</Card.Header>
                      <Card.Body>
                        <div className="d-grid gap-2">
                          <Button 
                            variant="warning"
                            onClick={() => handleClearCache('products')}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🗑️ Products Cache Temizle'}
                          </Button>

                          <Button 
                            variant="warning"
                            onClick={() => handleClearCache('collections')}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🗑️ Collections Cache Temizle'}
                          </Button>

                          <Button 
                            variant="warning"
                            onClick={() => handleClearCache('phone-models')}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🗑️ Phone Models Cache Temizle'}
                          </Button>

                          <hr />

                          <Button 
                            variant="info"
                            onClick={() => handleClearCache('products', true)}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🔗 Products + Dependencies Temizle'}
                          </Button>

                          <Button 
                            variant="info"
                            onClick={() => handleClearCache('collections', true)}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🔗 Collections + Dependencies Temizle'}
                          </Button>

                          <hr />

                          <Button 
                            variant="danger"
                            onClick={handleEmergencyCleanup}
                            disabled={clearingCache}
                          >
                            {clearingCache ? '🔄 Temizleniyor...' : '🚨 Acil Durum Temizliği'}
                          </Button>
                        </div>

                        <div className="mt-3">
                          <small className="text-muted">
                            <strong>📋 Açıklamalar:</strong><br/>
                            • <strong>Normal Temizleme:</strong> Sadece belirtilen cache temizlenir<br/>
                            • <strong>Dependencies:</strong> İlgili bağımlı cache'ler de temizlenir<br/>
                            • <strong>Acil Durum:</strong> Memory pressure yüksekse kullanın
                          </small>
                        </div>
                      </Card.Body>
                    </Card>

                    {/* Cache Policies Info */}
                    <Card>
                      <Card.Header>📖 Cache Policies</Card.Header>
                      <Card.Body>
                        <div style={{ fontSize: '0.9em' }}>
                          <div className="d-flex justify-content-between">
                            <span>🔒 STATIC:</span>
                            <span>2 saat</span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span>⚖️ STABLE:</span>
                            <span>30 dakika</span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span>⚡ DYNAMIC:</span>
                            <span>5 dakika</span>
                          </div>
                          <div className="d-flex justify-content-between">
                            <span>🔄 REALTIME:</span>
                            <span>1 dakika</span>
                          </div>
                        </div>
                        <hr />
                        <div style={{ fontSize: '0.8em' }}>
                          <strong>🎯 Current Mappings:</strong><br/>
                          Collections → STABLE<br/>
                          Products → DYNAMIC<br/>
                          Phone Models → STATIC<br/>
                          Address → STABLE
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Tab.Pane>

            {/* API Logları içeriği kaldırıldı */}
          </Tab.Content>
        </Tab.Container>

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          backdrop="static"
          keyboard={false}
        >
          <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>
                {modalType.startsWith('edit_') ? 'Düzenle' : 'Yeni Ekle'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalType.includes('phone_models') && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Marka</Form.Label>
                    <Form.Control
                      type="text"
                      name="brand"
                      value={formData.brand || ''}
                      onChange={handleChange}
                      required
                      placeholder="Örn: iPhone"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Model</Form.Label>
                    <Form.Control
                      type="text"
                      name="model_name"
                      value={formData.model_name || ''}
                      onChange={handleChange}
                      required
                      placeholder="Örn: 14 Pro Max"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Aktif"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </>
              )}

              {modalType.includes('products') && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Ürün Adı</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Fiyat</Form.Label>
                    <Form.Control
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Koleksiyon</Form.Label>
                    <Form.Select
                      name="collection_id"
                      value={formData.collection_id || ''}
                      onChange={handleChange}
                    >
                      <option value="">Koleksiyon Seçin</option>
                      {collections.map(collection => (
                        <option key={collection.id} value={collection.id}>
                          {collection.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Ürün Tipi</Form.Label>
                    <Form.Select
                      name="product_type_id"
                      value={formData.product_type_id || ''}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Ürün Tipi Seçin</option>
                      {productTypes.map(productType => (
                        <option key={productType.id} value={productType.id}>
                          {productType.display_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Telefon Modelleri</Form.Label>
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {Object.entries(groupedPhoneModels).map(([brand, models]) => (
                        <div key={brand} className="mb-2">
                          <h6>{brand}</h6>
                          {models.map(model => (
                            <Form.Check
                              key={model.id}
                              type="checkbox"
                              label={model.model_name}
                              checked={selectedModels.includes(model.id.toString())}
                              onChange={() => handleModelSelect(model.id.toString())}
                            />
                          ))}
                        </div>
                      ))}
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Açıklama</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Resim</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setImageFile(file);
                          setImagePreview(URL.createObjectURL(file));
                        } else {
                          // Dosya seçimi iptal edildiğinde
                          setImageFile(null);
                          // Eğer düzenleme modundaysak ve önceden bir resim varsa, onu koruyalım
                          if (modalType.startsWith('edit_') && formData.images) {
                            setImagePreview(formData.images);
                          } else {
                            setImagePreview(null);
                          }
                        }
                      }}
                    />
                    {imagePreview && (
                      <div className="position-relative mt-2">
                        <img
                          src={imagePreview.startsWith('blob:') ? imagePreview : formData.images}
                          alt="Preview"
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                        <Button 
                          variant="danger" 
                          size="sm" 
                          className="position-absolute" 
                          style={{ top: 0, right: 0 }}
                          onClick={() => {
                            setImageFile(null);
                            setImagePreview(null);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Maskesiz Resim</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setNoMaskImageFile(file);
                          setNoMaskImagePreview(URL.createObjectURL(file));
                        } else {
                          // Dosya seçimi iptal edildiğinde
                          setNoMaskImageFile(null);
                          // Eğer düzenleme modundaysak ve önceden bir resim varsa, onu koruyalım
                          if (modalType.startsWith('edit_') && formData.no_mask) {
                            setNoMaskImagePreview(formData.no_mask);
                          } else {
                            setNoMaskImagePreview(null);
                          }
                        }
                      }}
                    />
                    {noMaskImagePreview && (
                      <div className="position-relative mt-2">
                        <img
                          src={noMaskImagePreview.startsWith('blob:') ? noMaskImagePreview : formData.no_mask}
                          alt="Maskesiz Preview"
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                        <Button 
                          variant="danger" 
                          size="sm" 
                          className="position-absolute" 
                          style={{ top: 0, right: 0 }}
                          onClick={() => {
                            setNoMaskImageFile(null);
                            setNoMaskImagePreview(null);
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      </div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Aktif"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  {modalType.includes('custom-products') && false && (
                    <Form.Group className="mb-3">
                      <Form.Check
                        type="checkbox"
                        label="Müşteri Onayı"
                        name="is_approval"
                        checked={formData.is_approval}
                        onChange={handleChange}
                      />
                      <Form.Text className="text-muted">
                        Müşteri tasarımı onaylandıysa işaretleyin.
                      </Form.Text>
                    </Form.Group>
                  )}
                </>
              )}

              {modalType.includes('collections') && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Koleksiyon Adı</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Açıklama</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Resim</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setImageFile(file);
                          setImagePreview(URL.createObjectURL(file));
                        }
                      }}
                    />
                    {imagePreview && (
                      <img
                        src={imagePreview.startsWith('blob:') ? imagePreview : formData.image}
                        alt="Preview"
                        style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                      />
                    )}
                  </Form.Group>
                </>
              )}

              {modalType.includes('design_library') && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Tasarım Adı</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Örn: Kelebek"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Açıklama</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Tasarım hakkında kısa bir açıklama"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Kategori</Form.Label>
                    <Form.Control
                      type="text"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      required
                      placeholder="Örn: Doğa, Semboller, Gök Cisimleri"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Görsel</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          setImageFile(file);
                          setImagePreview(URL.createObjectURL(file));
                        }
                      }}
                    />
                    {(imagePreview || formData.image_url) && (
                      <img
                        src={imagePreview || formData.image_url}
                        alt="Preview"
                        style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                      />
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Sıralama</Form.Label>
                    <Form.Control
                      type="number"
                      name="display_order"
                      value={formData.display_order}
                      onChange={handleChange}
                      required
                      min="1"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Durum</Form.Label>
                    <Form.Check
                      type="switch"
                      name="is_active"
                      checked={formData.is_active}
                      onChange={handleChange}
                      label="Aktif"
                    />
                  </Form.Group>
                </>
              )}

              {modalType.includes('colors') && (
                <>
                  <Form.Group className="mb-3">
                    <Form.Label>Renk Adı</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={colorFormData.name}
                      onChange={handleColorFormChange}
                      required
                      placeholder="Örn: Kırmızı, Mavi, Yeşil"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Renk Kodu</Form.Label>
                    <div className="d-flex gap-2 align-items-center">
                      <Form.Control
                        type="text"
                        name="code"
                        value={colorFormData.code || ''}
                        onChange={handleColorFormChange}
                        required
                        placeholder="Örn: blue, white, red"
                        style={{ flex: 1 }}
                      />
                      <div 
                        className="color-preview-large"
                        style={{ 
                          backgroundColor: colorFormData.code || '#FFFFFF',
                          width: '40px',
                          height: '40px',
                          borderRadius: '4px',
                          border: '1px solid #ddd'
                        }}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Aktif"
                      name="is_active"
                      checked={colorFormData.is_active}
                      onChange={handleColorFormChange}
                    />
                  </Form.Group>
                </>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Ürün Detay Görselleri</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleProductDetailsImagesChange}
                />
                {productDetailsImagePreviews.length > 0 && (
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    {productDetailsImagePreviews.map((preview, index) => (
                      <div key={index} className="position-relative">
                        <img
                          src={preview}
                          alt={`Detay Görsel ${index + 1}`}
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                        <Button 
                          variant="danger" 
                          size="sm" 
                          className="position-absolute" 
                          style={{ top: 0, right: 0, padding: '0.1rem 0.3rem' }}
                          onClick={() => removeProductDetailsImagePreview(index)}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
                {productDetailsImages && productDetailsImages.length > 0 && (
                  <div className="mt-3">
                    <div className="mb-2">Mevcut Detay Görselleri:</div>
                    <div className="d-flex flex-wrap gap-2">
                      {productDetailsImages.map((imageUrl, index) => (
                        <div key={index} className="position-relative">
                          <img
                            src={imageUrl}
                            alt={`Mevcut Detay Görsel ${index + 1}`}
                            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                          />
                          <Button 
                            variant="danger" 
                            size="sm" 
                            className="position-absolute" 
                            style={{ top: 0, right: 0, padding: '0.1rem 0.3rem' }}
                            onClick={() => {
                              const updatedImages = productDetailsImages.filter((_, i) => i !== index);
                              setProductDetailsImages(updatedImages);
                            }}
                          >
                            <FontAwesomeIcon icon={faTimes} />
                          </Button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <Form.Text className="text-muted">
                  Birden fazla detay görseli ekleyebilirsiniz. Bu görseller ürün detay sayfasında gösterilecektir.
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Aktif"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleChange}
                />
              </Form.Group>

              {modalType.includes('custom-products') && false && (
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Müşteri Onayı"
                    name="is_approval"
                    checked={formData.is_approval}
                    onChange={handleChange}
                  />
                  <Form.Text className="text-muted">
                    Müşteri tasarımı onaylandıysa işaretleyin.
                  </Form.Text>
                </Form.Group>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                İptal
              </Button>
              {modalType.includes('colors') ? (
                <Button 
                  variant="primary" 
                  onClick={modalType === 'edit_colors' ? handleColorEdit : handleColorAdd}
                  disabled={!colorFormData.name || !colorFormData.code || colorLoading}
                >
                  {colorLoading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    modalType === 'edit_colors' ? 'Güncelle' : 'Ekle'
                  )}
                </Button>
              ) : (
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    modalType.startsWith('edit_') ? 'Güncelle' : 'Ekle'
                  )}
                </Button>
              )}
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          show={confirmModal.show}
          onHide={() => setConfirmModal({ ...confirmModal, show: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>{confirmModal.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{confirmModal.message}</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setConfirmModal({ ...confirmModal, show: false })}
            >
              İptal
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                confirmModal.onConfirm();
                setConfirmModal({ ...confirmModal, show: false });
              }}
            >
              Sil
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showOrderModal}
          onHide={() => setShowOrderModal(false)}
          size="lg"
          backdrop="static"
          className="order-details-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Sipariş Detayları - {selectedOrder?.order_number}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedOrder && (
              <div className="order-details">
                <div className="section mb-4">
                  <h5 className="mb-3">Müşteri Bilgileri</h5>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td><strong>Ad Soyad</strong></td>
                        <td>{selectedOrder.first_name} {selectedOrder.last_name}</td>
                      </tr>
                      <tr>
                        <td><strong>E-posta</strong></td>
                        <td>{selectedOrder.email}</td>
                      </tr>
                      <tr>
                        <td><strong>Telefon</strong></td>
                        <td>{selectedOrder.phone}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="section mb-4">
                  <h5 className="mb-3">Sipariş Durumu</h5>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td><strong>Sipariş Durumu</strong></td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {getStatusBadge(selectedOrder.status)}
                            <Form.Select
                              size="sm"
                              style={{ width: 'auto' }}
                              value={selectedOrder.status}
                              onChange={(e) => handleUpdateOrderStatus(selectedOrder.id, e.target.value)}
                              disabled={updatingOrderStatus}
                            >
                              <option value="pending">Beklemede</option>
                              <option value="processing">İşleniyor</option>
                              <option value="completed">Tamamlandı</option>
                              <option value="failed">Başarısız</option>
                            </Form.Select>
                            {updatingOrderStatus && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Ödeme Durumu</strong></td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {getPaymentStatusBadge(selectedOrder.payment_status)}
                            {(() => {
                              // Kapıda ödeme kontrolü - farklı formatları destekle
                              const isCashOnDelivery = selectedOrder.payment_method === 'cashOnDelivery' || 
                                                       selectedOrder.payment_method === 'cash_on_delivery' ||
                                                       selectedOrder.payment_method === 'kapıda_ödeme' ||
                                                       selectedOrder.payment_method === 'kapida_odeme';
                              
                              return isCashOnDelivery ? (
                                <Form.Select
                                  size="sm"
                                  style={{ width: 'auto' }}
                                  value={selectedOrder.payment_status}
                                  onChange={(e) => handleUpdatePaymentStatus(selectedOrder.id, e.target.value)}
                                  disabled={updatingOrderStatus}
                                  className="ms-2"
                                >
                                  <option value="pending">Beklemede</option>
                                  <option value="success">Ödendi</option>
                                  <option value="failed">Ödenmedi</option>
                                </Form.Select>
                              ) : null;
                            })()}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Ödeme Türü</strong></td>
                        <td>{getPaymentMethodBadge(selectedOrder.payment_method)}</td>
                      </tr>
                      <tr>
                        <td><strong>Toplam Tutar</strong></td>
                        <td>{selectedOrder.total_amount?.toFixed(2)} TL</td>
                      </tr>
                      <tr>
                        <td><strong>Sipariş Tarihi</strong></td>
                        <td>
                          {new Date(selectedOrder.created_at).toLocaleDateString('tr-TR', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="section mb-4">
                  <h5 className="mb-3">Kargo Bilgileri</h5>
                  <Table bordered>
                    <tbody>
                      <tr>
                        <td><strong>Barkod</strong></td>
                        <td>
                          {selectedOrder.shipment?.barcode ? (
                            (() => {
                              const isCashOnDelivery = selectedOrder.payment_method === 'cashOnDelivery' || 
                                                       selectedOrder.payment_method === 'cash_on_delivery' ||
                                                       selectedOrder.payment_method === 'kapıda_ödeme' ||
                                                       selectedOrder.payment_method === 'kapida_odeme';
                              
                              return isCashOnDelivery ? (
                                <button 
                                  className="btn btn-sm btn-outline-success"
                                  onClick={() => handlePrintLabel(selectedOrder)}
                                  title="Kapıda ödeme etiketi yazdır"
                                  disabled={printingLabel && printingOrderId === selectedOrder.id}
                                >
                                  {printingLabel && printingOrderId === selectedOrder.id ? (
                                    <>⏳ Yazdırılıyor...</>
                                  ) : (
                                    <>📄 {selectedOrder.shipment.barcode}</>
                                  )}
                                </button>
                              ) : (
                                <a 
                                  href={selectedOrder.shipment.label_url} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary"
                                  title="Etiket görüntüle"
                                >
                                  🔗 {selectedOrder.shipment.barcode}
                                </a>
                              );
                            })()
                          ) : (
                            '-'
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Kargo Firması</strong></td>
                        <td>
                          {selectedOrder.shipment?.provider_code || '-'}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>Teslimat Adresi</strong></td>
                        <td>
                          {selectedOrder.address}, 
                          {selectedOrder.district} / 
                          {selectedOrder.city}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <div className="section">
                  <h5 className="mb-3">Sipariş Ürünleri</h5>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>Ürün Görseli</th>
                        <th>Ürün</th>
                        <th>Model</th>
                        <th>Renk</th>
                        <th>Adet</th>
                        <th>Birim Fiyat</th>
                        <th>Toplam</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        // Sipariş ürünlerini doğru formatta al
                        let cartItems = [];
                        
                        if (selectedOrder.cart_items && Array.isArray(selectedOrder.cart_items)) {
                          // Eski format: doğrudan dizi
                          cartItems = selectedOrder.cart_items;
                        } else if (selectedOrder.cart_items && typeof selectedOrder.cart_items === 'object') {
                          // Yeni format: { items: { items: [...] } }
                          if (selectedOrder.cart_items.items && selectedOrder.cart_items.items.items) {
                            cartItems = selectedOrder.cart_items.items.items;
                          }
                        }
                        
                        return cartItems.map((item, index) => (
                          <tr key={index}>
                            <td style={{ width: '80px', height: '80px', padding: '5px' }}>
                              <div style={{ 
                                width: '70px', 
                                height: '70px', 
                                borderRadius: '4px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#f8f9fa'
                              }}>
                                                                <img
                                  src={productDetails[item.product_id]?.images || ''}
                                  alt={item.name}
                                  style={{ 
                                    maxWidth: '100%', 
                                    maxHeight: '100%', 
                                    objectFit: 'contain'
                                  }}
                                  onError={handleImageError}
                                />
                              </div>
                            </td>
                            <td data-label="Ürün">{item.name}</td>
                            <td data-label="Model">
                              {phoneModelDetails[item.phone_model_id] ? 
                                `${phoneModelDetails[item.phone_model_id].brand} ${phoneModelDetails[item.phone_model_id].model_name}` : 
                                item.model_name || 'Yükleniyor...'
                              }
                            </td>
                            <td data-label="Renk">
                              {item.color ? (
                                <div className="d-flex align-items-center gap-2">
                                  <div
                                    className="color-preview"
                                    style={{
                                      backgroundColor: item.color.code,
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}
                                  />
                                  <span>{item.color.name}</span>
                                </div>
                              ) : item.color_name ? (
                                <div className="d-flex align-items-center gap-2">
                                  <span>{item.color_name}</span>
                                </div>
                              ) : (
                                '-'
                              )}
                            </td>
                            <td data-label="Adet">{item.quantity}</td>
                            <td data-label="Birim Fiyat">{item.price?.toFixed(2)} TL</td>
                            <td data-label="Toplam">{(item.quantity * item.price)?.toFixed(2)} TL</td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </Table>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              <div>
                {/* Tüm siparişler silinebilir, ancak tamamlanmış/ödenmiş siparişler için ekstra uyarı */}
                {selectedOrder && (
                  <Button 
                    variant={selectedOrder.status === 'completed' || selectedOrder.payment_status === 'success' ? 'warning' : 'danger'}
                    onClick={() => handleDeleteOrder(selectedOrder)}
                    disabled={deletingOrder}
                  >
                    {deletingOrder ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Siliniyor...
                      </>
                    ) : (
                      <>
                        {selectedOrder.status === 'completed' || selectedOrder.payment_status === 'success' ? '⚠️' : '🗑️'} 
                        {selectedOrder.status === 'completed' || selectedOrder.payment_status === 'success' ? 'Siparişi Sil (Uyarılı)' : 'Siparişi Sil'}
                      </>
                    )}
                  </Button>
                )}
              </div>
              <div>
                <Button variant="secondary" onClick={() => setShowOrderModal(false)}>
                  Kapat
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        {modalType === 'view_design' && selectedItem && (
        <Modal
            show={showModal}
          onHide={() => setShowModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Tasarım Detayları</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="design-details">
              <h5>Ürün Bilgileri</h5>
              <Table bordered>
                <tbody>
                  <tr>
                    <td><strong>Ürün Adı</strong></td>
                    <td>{selectedItem.name}</td>
                  </tr>
                  <tr>
                    <td><strong>Telefon Modeli</strong></td>
                    <td>{selectedItem.phone_models}</td>
                  </tr>
                  <tr>
                    <td><strong>Fiyat</strong></td>
                    <td>{selectedItem.price} TL</td>
                  </tr>
                </tbody>
              </Table>

              <h5 className="mt-4">Tasarım Detayları</h5>
              <div className="design-preview">
                {selectedItem.design_data && (
                  <pre style={{ 
                    background: '#f8f9fa', 
                    padding: '15px', 
                    borderRadius: '5px',
                    maxHeight: '300px',
                    overflow: 'auto'
                  }}>
                    {JSON.stringify(selectedItem.design_data, null, 2)}
                  </pre>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Kapat
            </Button>
          </Modal.Footer>
        </Modal>
        )}

        <Modal
          show={templateUploadModal.show}
          onHide={() => setTemplateUploadModal({ ...templateUploadModal, show: false })}
          size="lg"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {templateUploadModal.modelName} - {templateUploadModal.isTemplate ? 'Referans' : 'Maske'} Görsel Yükle
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Görsel Seçin</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleTemplateImageChange}
                />
                <Form.Text className="text-muted">
                  Önerilen: PNG formatında, şeffaf arka planlı görsel
                </Form.Text>
              </Form.Group>
              
              {templateImagePreview && (
                <div className="mb-3">
                  <p className="mb-2">Önizleme:</p>
                  <div className="template-preview-container">
                    <img 
                      src={templateImagePreview} 
                      alt="Preview" 
                      className="img-fluid template-preview"
                      style={{ 
                        maxHeight: '300px', 
                        maxWidth: '100%', 
                        display: 'block', 
                        margin: '0 auto',
                        border: '1px solid #dee2e6',
                        borderRadius: '4px',
                        padding: '10px',
                        backgroundColor: templateUploadModal.isTemplate ? '#fff' : '#f8f9fa'
                      }}
                    />
                  </div>
                </div>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setTemplateUploadModal({ ...templateUploadModal, show: false })}>
              İptal
            </Button>
            <Button 
              variant="primary" 
              onClick={uploadTemplateImage} 
              disabled={!templateImageFile || uploadingTemplate}
            >
              {uploadingTemplate ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Yükleniyor...
                </>
              ) : (
                'Görsel Yükle'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          show={toast.show}
          onClose={() => setToast({ ...toast, show: false })}
          delay={3000}
          autohide
          style={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            minWidth: '250px'
          }}
          bg={toast.type}
        >
          <Toast.Header>
            <strong className="me-auto">Bildirim</strong>
          </Toast.Header>
          <Toast.Body className={toast.type === 'danger' ? 'text-white' : ''}>
            {toast.message}
          </Toast.Body>
        </Toast>
      </Container>
      
      {/* Image Preview Modal */}
      <Modal 
        show={showImagePreview} 
        onHide={() => setShowImagePreview(false)} 
        centered
        size="lg"
        style={{ zIndex: 1500 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Görsel Önizleme</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-4">
          {previewImage ? (
            <img 
              src={previewImage} 
              alt="Önizleme" 
              style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }} 
            />
          ) : (
            <div className="p-5 text-muted">Görsel yüklenemedi</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImagePreview(false)}>
            Kapat
          </Button>
          {previewImage && (
            <Button 
              variant="primary" 
              onClick={() => window.open(previewImage, '_blank')}
            >
              Görseli Yeni Sekmede Aç
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Resim Galerisi Modalı */}
      <Modal
        show={showImageGallery}
        onHide={() => setShowImageGallery(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Ürün Detay Görselleri</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap gap-3 justify-content-center">
            {imagePreviewGallery.map((image, index) => (
              <div 
                key={index}
                style={{ 
                  width: '150px', 
                  height: '150px', 
                  borderRadius: '4px',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#f8f9fa',
                  cursor: 'pointer',
                  border: '1px solid #dee2e6'
                }}
                onClick={() => handleImagePreview(image)}
              >
                <img
                  src={image}
                  alt={`Detay Görsel ${index + 1}`}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '100%', 
                    objectFit: 'contain'
                  }}
                  onError={handleImageError}
                />
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageGallery(false)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PDF Görüntüleme Modal'ı (Mobil için) */}
      <Modal 
        show={pdfModal.show} 
        onHide={() => setPdfModal({ show: false, url: '', orderNumber: '' })}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>📄 Etiket - {pdfModal.orderNumber}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: '70vh', padding: 0 }}>
          {pdfModal.url && (
            <iframe
              src={pdfModal.url}
              style={{
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              title={`Etiket - ${pdfModal.orderNumber}`}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button 
              variant="outline-primary" 
              onClick={() => {
                const link = document.createElement('a');
                link.href = pdfModal.url;
                link.download = `etiket-${pdfModal.orderNumber}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              📥 İndir
            </Button>
            <Button 
              variant="secondary" 
              onClick={() => setPdfModal({ show: false, url: '', orderNumber: '' })}
            >
              Kapat
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Stok Bilgisi Modal'ı */}
      <Modal
        show={showStockModal}
        onHide={handleStockModalCancel}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center gap-2">
              <span>📱 Stok Bilgisi</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <h6 className="text-muted mb-2">Telefon Modeli:</h6>
            <p className="mb-3 fw-bold">{stockModalData.phoneModelName}</p>
            
            <h6 className="text-muted mb-2">Seçilen Renk:</h6>
            <div className="d-flex align-items-center gap-2 mb-3">
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  backgroundColor: stockModalData.colorCode,
                  border: '2px solid #dee2e6',
                  borderRadius: '6px'
                }}
              />
              <span className="fw-bold">{stockModalData.colorName}</span>
              <Badge bg="secondary">{stockModalData.colorCode}</Badge>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Başlangıç Stok Miktarı</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={stockModalData.stock}
              onChange={(e) => setStockModalData(prev => ({
                ...prev,
                stock: parseInt(e.target.value) || 0
              }))}
              placeholder="Stok miktarını girin"
              className="form-control-lg"
            />
            <Form.Text className="text-muted">
              Bu renk-model kombinasyonu için başlangıç stok miktarını belirleyin.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={handleStockModalCancel}
            disabled={addingColor}
          >
            İptal
          </Button>
          <Button 
            variant="primary" 
            onClick={handleStockModalConfirm}
            disabled={addingColor}
          >
            {addingColor ? (
              <>
                <Spinner size="sm" className="me-2" />
                Ekleniyor...
              </>
            ) : (
              <>
                <span className="me-2">✅</span>
                Rengi Ekle
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Sipariş Silme Onay Modal'ı */}
      <Modal
        show={showDeleteOrderModal}
        onHide={handleCancelDeleteOrder}
        centered
        backdrop="static"
        className="order-delete-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center gap-2">
              <span className="text-danger">🗑️ Sipariş Silme Onayı</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {orderToDelete && (
            <div className="text-center">
              <div className="mb-4">
                <div className="alert alert-warning">
                  <strong>⚠️ Dikkat!</strong> Bu işlem geri alınamaz!
                </div>
                
                {/* Ekstra uyarılar */}
                {(orderToDelete.status === 'completed' || orderToDelete.payment_status === 'success') && (
                  <div className="alert alert-danger">
                    <strong>🚨 Önemli Uyarı!</strong>
                    <ul className="mb-0 mt-2">
                      {orderToDelete.status === 'completed' && (
                        <li>Bu sipariş <strong>tamamlanmış</strong> durumda!</li>
                      )}
                      {orderToDelete.payment_status === 'success' && (
                        <li>Bu sipariş <strong>ödenmiş</strong> durumda!</li>
                      )}
                      <li>Bu tür siparişlerin silinmesi <strong>muhasebe kayıtlarını</strong> etkileyebilir!</li>
                      <li>Silmeden önce <strong>yedek almanız</strong> önerilir!</li>
                    </ul>
                  </div>
                )}
              </div>
              
              <h5 className="mb-3">Sipariş Bilgileri:</h5>
              <div className="row text-start">
                <div className="col-6">
                  <strong>Sipariş No:</strong>
                </div>
                <div className="col-6">
                  {orderToDelete.order_number}
                </div>
                
                <div className="col-6">
                  <strong>Müşteri:</strong>
                </div>
                <div className="col-6">
                  {orderToDelete.first_name} {orderToDelete.last_name}
                </div>
                
                <div className="col-6">
                  <strong>Tutar:</strong>
                </div>
                <div className="col-6">
                  {orderToDelete.total_amount} TL
                </div>
                
                <div className="col-6">
                  <strong>Durum:</strong>
                </div>
                <div className="col-6">
                  {getStatusBadge(orderToDelete.status)}
                </div>
                
                <div className="col-6">
                  <strong>Ödeme Durumu:</strong>
                </div>
                <div className="col-6">
                  {getPaymentStatusBadge(orderToDelete.payment_status)}
                </div>
              </div>
              
              <div className="mt-4">
                <p className="text-muted">
                  <strong>Silinecek veriler:</strong>
                </p>
                <ul className="text-start text-muted">
                  <li>Sipariş kaydı</li>
                  <li>Kargo bilgileri</li>
                  <li>Alıcı adres bilgileri</li>
                  <li>Sipariş ürünleri</li>
                  <li>SMS doğrulama kayıtları (varsa)</li>
                </ul>
              </div>
              
              <div className="alert alert-danger mt-3">
                <strong>Bu siparişi silmek istediğinizden emin misiniz?</strong>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={handleCancelDeleteOrder}
            disabled={deletingOrder}
          >
            İptal
          </Button>
          <Button 
            variant={orderToDelete && (orderToDelete.status === 'completed' || orderToDelete.payment_status === 'success') ? 'warning' : 'danger'}
            onClick={handleConfirmDeleteOrder}
            disabled={deletingOrder}
          >
            {deletingOrder ? (
              <>
                <Spinner size="sm" className="me-2" />
                Siliniyor...
              </>
            ) : (
              <>
                {orderToDelete && (orderToDelete.status === 'completed' || orderToDelete.payment_status === 'success') ? '🚨' : '🗑️'} 
                Evet, Siparişi Sil
                {orderToDelete && (orderToDelete.status === 'completed' || orderToDelete.payment_status === 'success') && ' (Uyarılı)'}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default AdminPanel; 